// Basic translation dictionaries. Hungarian is default.
// NOTE: Keep keys consistent; fallback order: selected -> hu -> key.
export const languages = [
  {
    "code": "hu",
    "label": "Magyar",
    "flag": "🇭🇺"
  },
  {
    "code": "en",
    "label": "English",
    "flag": "🇬🇧"
  },
  {
    "code": "de",
    "label": "Deutsch",
    "flag": "🇩🇪"
  },
  {
    "code": "pl",
    "label": "Polski",
    "flag": "🇵🇱"
  },
  {
    "code": "cs",
    "label": "Čeština",
    "flag": "🇨🇿"
  },
  {
    "code": "sk",
    "label": "Slovenčina",
    "flag": "🇸🇰"
  },
  {
    "code": "ro",
    "label": "Română",
    "flag": "🇷🇴"
  },
  {
    "code": "bg",
    "label": "Български",
    "flag": "🇧🇬"
  },
  {
    "code": "ru",
    "label": "Русский",
    "flag": "🇷🇺"
  }
];

export const dictionaries = {
  "hu": {
    "appTitle": "SmartBin Vezérlőpult",
    "logout": "Kijelentkezés",
    "common": {
      "refresh": "Frissítés",
      "saving": "Mentés...",
      "hideDeleted": "Töröltek elrejtése",
      "edit": "Szerkesztés",
      "save": "Mentés",
      "cancel": "Mégse",
      "preview": "Előnézet",
      "apply": "Alkalmaz",
      "geocoding": "Geokódolás...",
      "noResult": "Nincs találat",
      "suggestions": "Javaslatok",
      "noSuggestions": "Nincs javaslat",
      "selectLocation": "Válassz helyet",
      "all": "Összes",
      "orderingMode": "Sorrend mód",
      "orderingStart": "Sorrend beállítása",
      "orderingStop": "Sorrend vége",
      "orderingSave": "Sorrend mentése",
      "orderingCancel": "Mégse",
      "orderingCol": "Sorrend",
      "addressCol": "Cím / Koordináta",
      "addressFallback": "koordináta",
      "address": "Cím",
      "coordinates": "Koordináták",
      "confirm": "Igen"
    },
    "menu": {
      "bins": "Kukák",
      "users": "Felhasználók",
      "settings": "Beállítások",
      "logs": "Logok",
      "sites": "Telephelyek",
      "fileManagement": "Fájlok",
      "docs": "Dokumentáció"
    },
    "bins": {
      "tooltip": {
        "fill": "Telítettség",
        "door": "Ajtó",
        "battery": "Akkumulátor",
        "batteryVolts": "Akkumulátor (V)",
        "heartbeat": "Életjel",
        "lastHeartbeat": "Utolsó életjel"
      },
      "collectionList": "Ürítési lista",
      "collectionListTitle": "Nyomtatható ürítési lista",
      "collectionListGenerate": "Megnyitás",
      "collectionListSort": {
        "order": "Telep. sorrend",
        "fill": "Telítettség",
        "mixed": "Vegyes"
      },
      "collectionListUpdatedWithin": "Friss (perc)",
      "collectionListIncludeUnordered": "Sorrend nélküli is",
      "collectionListHint": "A Megnyitás gomb új lapon HTML formában jeleníti meg, ahonnan nyomtatható.",
      "maintenanceList": "Karbantartási lista",
      "maintenanceListTitle": "Nyomtatható karbantartási lista",
      "maintenanceListGenerate": "Megnyitás",
      "maintenanceListSort": {
        "battery": "Akkufeszültség"
      },
      "maintenanceListHint": "A Megnyitás gomb új lapon HTML formában jeleníti meg, ahonnan nyomtatható.",
      "selectSiteFirst": "Először válassz telephelyet",
      "delete": "Törlés",
      "restore": "Visszaállítás",
      "deletedBadge": "törölt",
      "map": "Térkép",
      "list": "Lista",
      "addNew": "Új kuka hozzáadása",
      "add": "Hozzáadás",
      "listTitle": "Kukák listája",
      "empty": "Nincs még kuka. Adj hozzá egyet fent.",
      "emptyNoSites": "Kuka hozzáadása előtt legalább egy telephelyet fel kell venni.",
      "detailsTab": "Részletek",
      "form": {
        "identifier": "Azonosító",
        "identifierPlaceholder": "pl. BIN-001",
        "latitudePlaceholder": "47.49",
        "longitudePlaceholder": "19.04",
        "add": "Hozzáadás",
        "saving": "Mentés...",
        "errorIdentifierRequired": "Azonosító kötelező"
      },
      "details": {
        "mapPreview": "Térkép előnézet",
        "noCoordinates": "Nincsenek koordináták",
        "latitude": "Szélesség",
        "longitude": "Hosszúság",
        "useManual": "Kézi koordináta megadás",
        "stats": {
          "filling": "Telítettség",
          "state": "Állapot",
          "battery": "Akkumulátor",
          "solar": "Napelem",
          "signal": "Jel",
          "availability": "Elérhetőség",
          "unlocked": "Nyitott",
          "locked": "Zárt",
          "signalExcellent": "Kiváló",
          "signalGood": "Jó",
          "signalWeak": "Gyenge"
        },
        "innerTabs": {
          "details": "Részletek",
          "history": "Előzmények",
          "chart": "Grafikon",
          "settings": "Beállítások",
          "lock": "Zár beállítások",
          "service": "Szerviz",
          "availability": "Elérhetőség",
          "report": "Riport"
        },
        "fields": {
          "serial": "Sorozatszám",
          "name": "Név",
          "description": "Leírás",
          "installationDate": "Telepítés dátuma",
          "version": "Verzió",
          "lastContact": "Utolsó kapcsolat",
          "lastEmptied": "Utolsó ürítés",
          "district": "Kerület",
          "location": "Pozíció"
        },
        "edit": "Szerkesztés",
        "editPosition": "Pozíció szerkesztése",
        "dragHint": "Húzd a kukát a térképen az új koordináták beállításához, majd mentsd."
      },
      "mapLegend": {
        "title": "Telítettség",
        "low": "< 70%",
        "medium": "70–89%",
        "high": "≥ 90%",
        "noData": "Nincs adat"
      },
      "latch": {
        "open": "Nyitva",
        "closed": "Zárva",
        "actionOpen": "kapcsolás = Nyitás",
        "actionClose": "kapcsolás = Zárás",
        "sendOpen": "Nyitás",
        "sendClose": "Zárás",
        "sending": "Küldés..."
      }
    },
    "docs": {
      "title": "Dokumentáció",
      "intro": "Az alkalmazás áttekintése és működése szerepkörök szerint.",
      "menu": {
        "title": "Menüpontok"
      },
      "backTop": "Vissza az elejére",
      "general": {
        "title": "Általános tudnivalók",
        "purpose": "A SmartBin alkalmazás célja, hogy átláthatóan és valós időben támogassa az okoskukák üzemeltetését. Láthatóvá teszi az aktuális telítettséget, az akkumulátor állapotát és a zár státuszát, valamint segíti az ürítési tervezést és a médiaüzenetek (hang/kép) kiosztását.",
        "structure": "Az alkalmazás felépítése egyszerű: a bal oldali menüben a fő funkciók érhetők el (Kukák, Telephelyek, Fájlok, Felhasználók, Beállítások, Logok). A Kukák menüben térképen és listában böngészhető az állapot, a részletes nézetben grafikonok és előzmények láthatók. A Fájlok menüben hang- és képfájlok kezelhetők és hozzárendelhetők a kukákhoz. A Logok nézet az összes fontos művelet és esemény auditját mutatja. Főbb funkciók és jellemzők:",
        "features": {
          "mapList": "Térkép és lista: gyors áttekintés színkódolt telítettséggel, akkumulátor és zár jelzéssel.",
          "collection": "Ürítési lista: szűrés telephely és küszöbök szerint, nyomtatható/exportálható lista.",
          "media": "Média: hang/kép fájlok feltöltése és kiosztása; eszközök visszaigazolása (ACK) megjelenik a Logokban.",
          "sites": "Telephelyek: helyszínek kezelése, amelyekhez a kukák tartoznak.",
          "users": "Felhasználók: hozzáadás, módosítás, jelszó csere; szerepkörök szerint eltérő jogosultságok.",
          "settings": "Beállítások: nyelv és telemetriai küszöbök (akkumulátor, telítettség), amelyek a megjelenített jelzéseket befolyásolják.",
          "logs": "Logok: minden lényeges rendszer- és felhasználói művelet naplózása, részletek és időszak szerinti szűrőkkel."
        },
        "roles": "Szerepkörök: felhasználók alapvetően megtekinthetnek és böngészhetnek; a menedzser és admin módosíthat, törölhet és rendszert kezelhet. A szuperadmin rendszerszintű jogosultsággal rendelkezik, és bizonyos listanézetekben rejtve maradhat.",
        "tips": "Tippek: használd a szűrőket a gyors kereséshez; a listák rendezhetők és exportálhatók. Ha egy eszköz épp offline vagy nem érhető el, az állapotjelzések ezt tükrözhetik. Az esetleges hiba- vagy visszajelzések a Logokban követhetők nyomon."
      },
      "legend": {
        "title": "Jelmagyarázat",
        "fill": {
          "title": "Telítettség",
          "green": "Zöld",
          "yellow": "Sárga",
          "red": "Piros",
          "none": "Nincs adat"
        },
        "battery": {
          "title": "Akkumulátor",
          "ok": "Rendben",
          "low": "Alacsony"
        },
        "lock": {
          "title": "Zár",
          "closed": "Zárva",
          "open": "Nyitva"
        },
        "signal": {
          "title": "Jel",
          "excellent": "Kiváló",
          "good": "Jó",
          "weak": "Gyenge"
        },
        "mediaAck": {
          "title": "Média visszaigazolás (ACK)",
          "ok": "OK",
          "fail": "Hiba"
        },
        "media": {
          "title": "Média",
          "audio": "Hang",
          "image": "Kép"
        },
        "roles": {
          "title": "Szerepkörök",
          "superadmin": "Szuperadmin",
          "admin": "Admin",
          "manager": "Menedzser",
          "user": "Felhasználó"
        },
        "sites": {
          "title": "Telephelyek",
          "code": "Kód",
          "location": "Pozíció"
        }
      },
      "bins": {
        "title": "Kukák",
        "overview": "A Kukák menüben megtekintheted a térképet, listát és a kiválasztott kuka részleteit.",
        "steps1": "Kattints a bal oldali menüben a “Kukák” pontra. A felső sorban a “Térkép” és “Lista” nézetek között tudsz váltani. A térképen kattints egy ikonra a részletekhez; a listában kattints a sorra.",
        "map": "Térkép: színezett ikonok (zöld/sárga/piros), akkumulátor és zár állapot jelzések.",
        "list": "Lista: telítettség progress bar, akkumulátor feszültség, zár állapot, rendezés.",
        "details": "Részletek: mini térkép, állapotkártyák, grafikonok, előzmények.",
        "manage": "Kuka menedzsment: hozzáadás, módosítás, törlés, sorrend beállítása, ürítési lista generálása.",
        "steps2": "Új kuka: jobb felső “+ Új kuka”. Szerkesztés: részletek → “Szerkesztés”. Törlés: kuka sorában a “Törlés” ikon.",
        "order": "Sorrend: a listában a “Fel/Le” vezérlőkkel vagy húzással állítható; mentsd a “Sorrend mentése” gombbal.",
        "collection": "Ürítési lista: válassz szűrőt (telephely, telítettség), majd “Lista generálása”; exportálható PDF/CSV formátumba.",
        "userView": "Felhasználóként megtekintheted a térképet és listát, a részletek között a telítettség és állapot információkat."
      },
      "sites": {
        "title": "Telephelyek",
        "overview": "Telephelyek kezelése és áttekintése."
      },
      "files": {
        "title": "Fájlok",
        "overview": "Hang- és képfájlok kezelése, hozzárendelés a kukákhoz.",
        "steps": "Nyisd meg a “Fájlok” menüt. Feltöltés: húzd be a fájlt vagy kattints a “Feltöltés” gombra. Hozzárendelés: válassz kukát, majd a fájlnál “Hozzárendelés”."
      },
      "users": {
        "title": "Felhasználók",
        "overview": "Felhasználók kezelése: létrehozás, módosítás, törlés, jelszó csere.",
        "steps": "Menü: “Felhasználók”. Új: “+ Új felhasználó”. Szerkesztés: sor melletti “Szerkesztés”. Szerepkör: legördülőből állítható."
      },
      "settings": {
        "title": "Beállítások",
        "overview": "Globális beállítások: nyelv, telemetriai küszöbök (akkumulátor, telítettség), audit naplózás.",
        "steps": "Menü: “Beállítások”. A Telemetria részben állítsd az akkumulátor alsó küszöböt és a telítettség színküszöbeit, majd mentsd.",
        "tips": "Tipp: az (i) ikonokra húzva az egeret részletes magyarázat jelenik meg. Ha a zöld felső nem nagyobb a piros alsónál, a Mentés letiltható."
      },
      "admin": {
        "title": "Admin funkciók",
        "overview": "Audit logok, jogosultságkezelés, rendszerkonfiguráció és speciális beállítások."
      },
      "logs": {
        "title": "Logok",
        "overview": "A Logok menü az audit naplókat és eseményeket mutatja. Szűrhet időintervallum, entitás és művelet szerint, a részletekben pedig látható a változások előtte/utána állapota.",
        "mediaAck": "A média (kép/hang) küldések visszaigazolásai (ACK) külön jelöléssel jelennek meg, azonnal frissülnek realtime eseményekkel."
      }
    },
    "logs": {
      "title": "Audit naplók",
      "tabUsers": "Felhasználók",
      "tabBins": "Kukák",
      "tabMedia": "Fájlok",
      "loading": "Betöltés...",
      "time": "Idő",
      "action": "Művelet",
      "entity": "Entitás",
      "entityId": "Entitás ID",
      "entityIdBin": "Kuka ID",
      "entityIdSite": "Telephely ID",
      "settingCol": "Beállítás",
      "filterTimeFrom": "Kezdés",
      "filterTimeTo": "Vége",
      "userId": "Felhasználó ID",
      "empty": "Nincs adat",
      "notAuthorized": "Nincs jogosultság",
      "detailsTitle": "Részletek",
      "diffBefore": "Előtte",
      "diffAfter": "Utána",
      "diffChanged": "Változott mezők",
      "diffNoChanges": "Nincs változás",
      "close": "Bezárás",
      "showRaw": "Nyers nézet",
      "hideRaw": "Nyers nézet elrejtése"
    },
    "users": {
      "management": "Felhasználók kezelése",
      "users": "Felhasználók",
      "edit": "Módosítás",
      "addUser": "Felhasználó hozzáadása",
      "username": "Felhasználónév",
      "email": "Email",
      "role": "Szerep",
      "actions": "Műveletek",
      "create": "Létrehozás",
      "cancel": "Mégse",
      "save": "Mentés",
      "passwordPlaceholder": "jelszó",
      "delete": "Törlés",
      "restore": "Visszaállítás",
      "deletedBadge": "törölt",
      "firstName": "Keresztnév",
      "lastName": "Vezetéknév",
      "phone": "Telefonszám",
      "validationMissingFields": "Add meg az email, jelszó, vezetéknév és keresztnév mezőket.",
      "changePassword": "Jelszó módosítás",
      "newPassword": "Új jelszó",
      "confirmPassword": "Jelszó megerősítése",
      "passwordUpdated": "Jelszó frissítve",
      "deleteProtectedSuperadmin": "A superadmin felhasználó nem törölhető.",
      "protectedSuperadminBadge": "Szuperadmin (védett)",
      "passwordTooShort": "Minimum 8 karakter",
      "passwordMismatch": "A két jelszó nem egyezik",
      "passwordWeak": "Gyenge jelszó: adj hozzá nagybetűt és számot",
      "passwordMedium": "Közepes jelszó: adj hozzá nagybetűt és számot",
      "passwordStrong": "Erős jelszó"
    },
    "confirm": {
      "titleDelete": "Felhasználó törlése",
      "titleRestore": "Felhasználó visszaállítása",
      "messageDelete": "Biztosan törlöd (soft delete) ezt a felhasználót? A felhasználó nem fog tudni belépni, amíg vissza nem állítod.",
      "messageRestore": "Vissza szeretnéd állítani ezt a felhasználót? Újra be tud majd lépni.",
      "proceed": "Igen",
      "cancel": "Mégse"
    },
    "confirmBin": {
      "titleDelete": "Kuka törlése",
      "titleRestore": "Kuka visszaállítása",
      "messageDelete": "Biztosan törlöd (soft delete) ezt a kukát? A térképről eltűnik, amíg vissza nem állítod.",
      "messageRestore": "Visszaállítod ezt a kukát? Újra meg fog jelenni.",
      "proceed": "Igen",
      "cancel": "Mégse"
    },
    "auth": {
      "login": "Bejelentkezés",
      "register": "Regisztráció",
      "email": "Email",
      "password": "Jelszó",
      "haveAccount": "Már van fiókod?",
      "noAccount": "Nincs még fiókod?",
      "loginHere": "Jelentkezz be itt",
      "registerHere": "Regisztrálj itt",
      "username": "Felhasználónév",
      "unexpectedError": "Váratlan hiba történt. Próbáld újra."
    },
    "settings": {
      "title": "Beállítások",
      "language": "Nyelv",
      "selectLanguage": "Válassz nyelvet",
      "batteryLowThreshold": "Akkumulátor alacsony küszöb (V)",
      "batteryLowThresholdHint": "A térképen látható akkumulátor ikon megjelenése ehhez a küszöbhöz igazodik.",
      "fillGreenThreshold": "Telítettség zöld küszöb (%)",
      "fillYellowThreshold": "Telítettség sárga küszöb (%)",
      "fillRedThreshold": "Telítettség piros küszöb (%)",
      "fillThresholdsHint": "A telítettség színei (zöld/sárga/piros) ezekhez a küszöbökhöz igazodnak.",
      "saved": "Beállítások mentve"
    },
    "media": {
      "title": "Fájlkezelés",
      "audioTab": "Hangok",
      "imageTab": "Képek",
      "upload": "Feltöltés",
      "uploading": "Feltöltés...",
      "assign": "Hozzárendelés",
      "assignBinPlaceholder": "Bin ID hozzárendeléshez",
      "publish": "Publikálás",
      "publishDisabledHint": "Később lesz elérhető",
      "fileName": "Fájlnév",
      "fileType": "Típus",
      "version": "Verzió",
      "bin": "Kuka",
      "sizeBytes": "Méret (B)",
      "noFiles": "Nincs fájl",
      "noMediaForBin": "Nincs média ehhez a kukához.",
      "open": "Megnyitás",
      "delete": "Törlés",
      "deleteDisabledHint": "Törlés hamarosan elérhető",
      "deleteConfirm": "Biztosan törlöd? Ez nem visszavonható.",
      "deleteHint": "Fájl végleges törlése",
      "deleting": "Törlés...",
      "actionColumn": "Művelet",
      "binColumn": "Kuka",
      "allFiles": "Összes fájl",
      "bulkActionHint": "Egyedi műveletek",
      "actionSelectPlaceholder": "Művelet...",
      "binSelectPlaceholder": "Kuka...",
      "action": {
        "open": "Nyitás",
        "compression": "Tömörítés",
        "full": "Megtelt",
        "notice": "Értesítés",
        "standby": "Készenlét"
      },
      "sitesGroup": "Telephelyek",
      "binsGroup": "Kukák",
      "confirmTitle": "Megerősítés",
      "confirmPublish":"Biztosan publikálod ezt a fájlt?",
      "confirmPublishAll": "Biztosan publikálod az összes fájlt?",
      "publishMissingAction": "Minden fájlnál válassz műveletet",
      "deleteAllConfirm": "Biztosan törlöd az összes fájlt?"
    },
    "sites": {
      "title": "Telephelyek",
      "list": "Telephely lista",
      "addNew": "Új telephely",
      "selectPlaceholder": "Válassz telephelyet",
      "validationSelectSite": "Válassz telephelyet",
      "fields": {
        "code": "Kód",
        "name": "Név",
        "address": "Cím",
        "phone": "Telefon",
        "latitude": "Szélesség",
        "longitude": "Hosszúság",
        "site": "Telephely",
        "coordinates": "Koordináták"
      },
      "placeholders": {
        "code": "pl. SITE1",
        "name": "Név",
        "address": "Cím",
        "phone": "Telefon",
        "latitude": "47.49",
        "longitude": "19.04"
      },
      "form": {
        "code": "Kód",
        "name": "Név",
        "address": "Cím",
        "phone": "Telefon",
        "latitude": "Szélesség",
        "longitude": "Hosszúság",
        "create": "Létrehozás",
        "requiredCode": "Kód kötelező",
        "requiredName": "Név kötelező"
      },
      "validationCodeRequired": "Kód kötelező",
      "validationAddressChars": "Cím érvénytelen karaktereket tartalmaz",
      "validationAddressTooLong": "Cím túl hosszú (max 180)",
      "validationAddressNeedStreetNumber": "A cím tartalmazzon utcanevet és házszámot",
      "empty": "Nincs telephely. Hozz létre egyet.",
      "code": "Kód",
      "name": "Név",
      "address": "Cím",
      "phone": "Telefon"
    }
  },
  "en": {
    "appTitle": "SmartBin Dashboard",
    "logout": "Logout",
    "common": {
      "refresh": "Refresh",
      "saving": "Saving...",
      "hideDeleted": "Hide deleted",
      "edit": "Edit",
      "save": "Save",
      "cancel": "Cancel",
      "preview": "Preview",
      "apply": "Apply",
      "geocoding": "Geocoding...",
      "noResult": "No result",
      "suggestions": "Suggestions",
      "noSuggestions": "No suggestions",
      "selectLocation": "Select location",
      "all": "All",
      "orderingMode": "Ordering mode",
      "orderingStart": "Set order",
      "orderingStop": "End order",
      "orderingSave": "Save order",
      "orderingCancel": "Cancel",
      "orderingCol": "Order",
      "addressCol": "Address / Coordinate",
      "addressFallback": "coordinate",
      "address": "Address",
      "coordinates": "Coordinates",
      "confirm": "Yes"
    },
    "menu": {
      "bins": "Bins",
      "users": "Users",
      "settings": "Settings",
      "logs": "Logs",
      "sites": "Sites",
      "fileManagement": "File Management",
      "docs": "Documentation"
    },
    "logs": {
      "title": "Audit Logs",
      "tabUsers": "Users",
      "tabBins": "Bins",
      "loading": "Loading...",
      "time": "Time",
      "action": "Action",
      "entity": "Entity",
      "entityId": "Entity ID",
      "entityIdBin": "Bin ID",
      "entityIdSite": "Site ID",
      "settingCol": "Setting",
      "filterTimeFrom": "From",
      "filterTimeTo": "To",
      "userId": "User ID",
      "empty": "No data",
      "notAuthorized": "Not authorized",
      "detailsTitle": "Details",
      "diffBefore": "Before",
      "diffAfter": "After",
      "diffChanged": "Changed fields",
      "diffNoChanges": "No changes",
      "close": "Close",
      "showRaw": "Show raw",
      "hideRaw": "Hide raw",
      "tabMedia": "Fájlok"
    },
    "bins": {
      "tooltip": {
        "fill": "Filling",
        "door": "Door",
        "battery": "Battery",
        "batteryVolts": "Battery (V)",
        "heartbeat": "Heartbeat",
        "lastHeartbeat": "Last heartbeat"
      },
      "collectionList": "Collection list",
      "collectionListTitle": "Printable collection list",
      "collectionListGenerate": "Open",
      "collectionListSort": {
        "order": "Site order",
        "fill": "Fill level",
        "mixed": "Mixed"
      },
      "collectionListUpdatedWithin": "Fresh (min)",
      "collectionListIncludeUnordered": "Include unordered",
      "collectionListHint": "Open button shows printable HTML in new tab.",
      "maintenanceList": "Maintenance list",
      "maintenanceListTitle": "Printable maintenance list",
      "maintenanceListGenerate": "Open",
      "maintenanceListSort": {
        "battery": "Battery voltage"
      },
      "maintenanceListHint": "Open button shows printable HTML in new tab.",
      "selectSiteFirst": "Select a site first",
      "delete": "Delete",
      "restore": "Restore",
      "deletedBadge": "deleted",
      "map": "Map",
      "list": "List",
      "addNew": "Add new bin",
      "add": "Add",
      "listTitle": "List of bins",
      "empty": "No bins yet. Add one above.",
      "emptyNoSites": "Before adding a bin you must create at least one site.",
      "detailsTab": "Details",
      "form": {
        "identifier": "Identifier",
        "identifierPlaceholder": "e.g. BIN-001",
        "latitudePlaceholder": "47.49",
        "longitudePlaceholder": "19.04",
        "add": "Add",
        "saving": "Saving...",
        "errorIdentifierRequired": "Identifier required"
      },
      "details": {
        "mapPreview": "Map preview",
        "noCoordinates": "No coordinates",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "useManual": "Use manual set Coordinates",
        "stats": {
          "filling": "Filling",
          "state": "State",
          "battery": "Battery",
          "solar": "Solar",
          "signal": "Signal",
          "availability": "Availability",
          "unlocked": "Unlocked",
          "locked": "Locked",
          "signalExcellent": "Excellent",
          "signalGood": "Good",
          "signalWeak": "Weak"
        },
        "innerTabs": {
          "details": "Details",
          "history": "History",
          "chart": "Chart",
          "settings": "Settings",
          "lock": "Lock settings",
          "service": "Service",
          "availability": "Availability",
          "report": "Report"
        },
        "fields": {
          "serial": "Serial",
          "name": "Name",
          "description": "Description",
          "installationDate": "Installation date",
          "version": "Version",
          "lastContact": "Last contact",
          "lastEmptied": "Last emptied",
          "district": "District",
          "location": "Location"
        },
        "edit": "Edit",
        "editPosition": "Edit position",
        "dragHint": "Drag the bin on the map to set new coordinates, then save."
      },
      "mapLegend": {
        "title": "Filling",
        "low": "< 70%",
        "medium": "70–89%",
        "high": "≥ 90%",
        "noData": "No data"
      },
      "latch": {
        "open": "Open",
        "closed": "Closed",
        "actionOpen": "toggle = Open",
        "actionClose": "toggle = Close",
        "sendOpen": "Send Open",
        "sendClose": "Send Close",
        "sending": "Sending..."
      }
    },
    "docs": {
      "title": "Documentation",
      "intro": "Overview of the application by user roles.",
      "menu": {
        "title": "Sections"
      },
      "backTop": "Back to top",
      "general": {
        "title": "General Information",
        "purpose": "SmartBin helps operate bins transparently and in real time: it shows current fill level, battery status and lock state, assists with collection planning, and distributes media messages (audio/images).",
        "structure": "The app is straightforward: the left menu gives access to the main features (Bins, Sites, Files, Users, Settings, Logs). In Bins, view map and list with details, charts and history. In Files, manage audio/image files and assign them to bins. Logs shows an audit trail of key operations and events.",
        "features": {
          "mapList": "Map and list: quick overview with color-coded fill, battery and lock indicators.",
          "collection": "Collection list: filter by site and thresholds; printable/exportable.",
          "media": "Media: upload and distribute audio/image files; device acknowledgements (ACK) appear in Logs.",
          "sites": "Sites: manage locations to which bins belong.",
          "users": "Users: add, edit, change passwords; permissions differ by role.",
          "settings": "Settings: language and telemetry thresholds (battery, fill) affecting displayed indicators.",
          "logs": "Logs: auditing of essential system and user actions, with details and period filters."
        },
        "roles": "Roles: users can browse and view; managers and admins can modify, delete and administer the system. Superadmin has system-wide permissions and may remain hidden in some lists.",
        "tips": "Tips: use filters to find quickly; lists can be sorted and exported. If a device is offline/unreachable, indicators reflect that. Errors and acknowledgements are visible in Logs."
      },
      "legend": {
        "title": "Legend",
        "fill": {
          "title": "Fill",
          "green": "Green",
          "yellow": "Yellow",
          "red": "Red",
          "none": "No data"
        },
        "battery": {
          "title": "Battery",
          "ok": "OK",
          "low": "Low"
        },
        "lock": {
          "title": "Lock",
          "closed": "Closed",
          "open": "Open"
        },
        "signal": {
          "title": "Signal",
          "excellent": "Excellent",
          "good": "Good",
          "weak": "Weak"
        },
        "mediaAck": {
          "title": "Media ACK",
          "ok": "OK",
          "fail": "Fail"
        },
        "media": {
          "title": "Media",
          "audio": "Audio",
          "image": "Image"
        },
        "roles": {
          "title": "Roles",
          "superadmin": "Superadmin",
          "admin": "Admin",
          "manager": "Manager",
          "user": "User"
        },
        "sites": {
          "title": "Sites",
          "code": "Code",
          "location": "Location"
        }
      },
      "bins": {
        "title": "Bins",
        "overview": "In the Bins menu you can view the map, list and selected bin details.",
        "steps1": "Click “Bins” in the left menu. Use the top tabs to switch between Map and List. On the map click an icon for details; in the list click a row.",
        "map": "Map: color-coded icons (green/yellow/red), battery and lock overlays.",
        "list": "List: fill level progress bar, battery voltage, lock state, sorting.",
        "details": "Details: mini map, status cards, charts, history.",
        "manage": "Bin management: add, edit, delete, ordering, collection list generation.",
        "steps2": "New bin: top-right “+ New bin”. Edit: open details → “Edit”. Delete: click the “Delete” icon in the row.",
        "order": "Ordering: use Up/Down controls or drag in the list; save with “Save order”.",
        "collection": "Collection list: set filters (site, fill), then “Generate list”; export to PDF/CSV.",
        "userView": "As a user you can view the map and list, and details like fill level and status."
      },
      "sites": {
        "title": "Sites",
        "overview": "Manage and view sites."
      },
      "files": {
        "title": "Files",
        "overview": "Manage audio and image files, assign to bins.",
        "steps": "Open “Files”. Upload by dragging or clicking “Upload”. To assign, pick a bin then click “Assign” on the file."
      },
      "users": {
        "title": "Users",
        "overview": "Manage users: create, edit, delete, change password.",
        "steps": "Go to “Users”. New user: “+ New user”. Edit: “Edit” icon in the row. Role: choose from dropdown."
      },
      "settings": {
        "title": "Settings",
        "overview": "Global settings: language, telemetry thresholds (battery, fill), audit logging.",
        "steps": "Go to “Settings”. In Telemetry set battery low threshold and fill thresholds, then save.",
        "tips": "Tip: hover (i) icons for more info. If green upper ≤ red lower, Save may be disabled."
      },
      "admin": {
        "title": "Admin features",
        "overview": "Audit logs, role management, system configuration and advanced settings."
      },
      "logs": {
        "title": "Logs",
        "overview": "The Logs menu shows audit records and events. Filter by time, entity and action; details show before/after states of changes.",
        "mediaAck": "Media (image/audio) delivery acknowledgements (ACK) are highlighted and appear instantly via realtime events."
      }
    },
    "users": {
      "management": "Users Management",
      "users": "Users",
      "edit": "Edit",
      "addUser": "Add User",
      "username": "Username",
      "email": "Email",
      "role": "Role",
      "actions": "Actions",
      "create": "Create",
      "cancel": "Cancel",
      "save": "Save",
      "passwordPlaceholder": "password",
      "delete": "Delete",
      "restore": "Restore",
      "deletedBadge": "deleted",
      "firstName": "First Name",
      "lastName": "Last Name",
      "phone": "Phone",
      "validationMissingFields": "Please fill email, password, last name and first name.",
      "changePassword": "Change password",
      "newPassword": "New password",
      "confirmPassword": "Confirm password",
      "passwordUpdated": "Password updated",
      "passwordTooShort": "Minimum 8 characters",
      "passwordMismatch": "Passwords do not match",
      "passwordWeak": "Weak password: add uppercase and number",
      "passwordMedium": "Medium: add uppercase and number",
      "passwordStrong": "Strong password",
      "deleteProtectedSuperadmin": "A superadmin felhasználó nem törölhető.",
      "protectedSuperadminBadge": "Szuperadmin (védett)"
    },
    "confirm": {
      "titleDelete": "Delete User",
      "titleRestore": "Restore User",
      "messageDelete": "Are you sure you want to soft delete this user? They will not be able to log in until restored.",
      "messageRestore": "Restore this user? They will be able to log in again.",
      "proceed": "Yes",
      "cancel": "Cancel"
    },
    "confirmBin": {
      "titleDelete": "Delete Bin",
      "titleRestore": "Restore Bin",
      "messageDelete": "Are you sure you want to soft delete this bin? It will disappear from the map until restored.",
      "messageRestore": "Restore this bin? It will appear again on the map.",
      "proceed": "Yes",
      "cancel": "Cancel"
    },
    "auth": {
      "login": "Login",
      "register": "Register",
      "email": "Email",
      "password": "Password",
      "haveAccount": "Already have an account?",
      "noAccount": "Don't have an account?",
      "loginHere": "Login here",
      "registerHere": "Register here",
      "username": "Username",
      "unexpectedError": "An unexpected error occurred. Please try again."
    },
    "settings": {
      "title": "Settings",
      "language": "Language",
      "selectLanguage": "Select language",
      "batteryLowThreshold": "Battery low threshold (V)",
      "batteryLowThresholdHint": "Battery overlay on map follows this threshold.",
      "saved": "Settings saved",
      "fillGreenThreshold": "Telítettség zöld küszöb (%)",
      "fillYellowThreshold": "Telítettség sárga küszöb (%)",
      "fillRedThreshold": "Telítettség piros küszöb (%)",
      "fillThresholdsHint": "A telítettség színei (zöld/sárga/piros) ezekhez a küszöbökhöz igazodnak."
    },
    "media": {
      "title": "File Management",
      "audioTab": "Audio Files (WAV)",
      "imageTab": "Image Files (BMP)",
      "upload": "Upload",
      "uploading": "Uploading...",
      "assign": "Assign",
      "assignBinPlaceholder": "Bin ID for assign",
      "publish": "Publish",
      "publishDisabledHint": "Coming later",
      "fileName": "Filename",
      "fileType": "Type",
      "version": "Version",
      "bin": "Bin",
      "sizeBytes": "Size (B)",
      "noFiles": "No files",
      "noMediaForBin": "No media for this bin.",
      "open": "Open",
      "delete": "Delete",
      "deleteDisabledHint": "Delete coming soon",
      "deleteConfirm": "Are you sure? This cannot be undone.",
      "deleteHint": "Permanently delete file",
      "deleting": "Deleting...",
      "actionColumn": "Action",
      "binColumn": "Bin",
      "allFiles": "All files",
      "bulkActionHint": "Individual actions",
      "actionSelectPlaceholder": "Action...",
      "binSelectPlaceholder": "Bin...",
      "action": {
        "open": "Open",
        "compression": "Compression",
        "full": "Full",
        "notice": "Notice",
        "standby": "Standby"
      },
      "sitesGroup": "Sites",
      "binsGroup": "Bins",
      "confirmTitle": "Confirmation",
      "confirmPublish": "Are you sure you want to publish this file to the assigned bin?",
      "confirmPublishAll": "Are you sure you want to publish all files?",
      "publishMissingAction": "Select an action for every file",
      "deleteAllConfirm": "Are you sure you want to delete all files?"
    },
    "sites": {
      "title": "Sites",
      "list": "Site list",
      "addNew": "Add site",
      "selectPlaceholder": "Select site",
      "validationSelectSite": "Select a site",
      "fields": {
        "code": "Code",
        "name": "Name",
        "address": "Address",
        "phone": "Phone",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "site": "Site",
        "coordinates": "Coordinates"
      },
      "placeholders": {
        "code": "e.g. SITE1",
        "name": "Name",
        "address": "Address",
        "phone": "Phone",
        "latitude": "47.49",
        "longitude": "19.04"
      },
      "form": {
        "code": "Code",
        "name": "Name",
        "address": "Address",
        "phone": "Phone",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "create": "Create",
        "requiredCode": "Code is required",
        "requiredName": "Name is required"
      },
      "validationCodeRequired": "Code is required",
      "validationAddressChars": "Address has invalid characters",
      "validationAddressTooLong": "Address too long (max 180)",
      "validationAddressNeedStreetNumber": "Address must include street name and number",
      "empty": "No sites yet. Create one.",
      "code": "Code",
      "name": "Name",
      "address": "Address",
      "phone": "Phone"
    }
  },
  "de": {
    "appTitle": "SmartBin Dashboard",
    "logout": "Abmelden",
    "common": {
      "refresh": "Aktualisieren",
      "saving": "Speichern...",
      "all": "Alle",
      "orderingMode": "Reihenfolge",
      "orderingStart": "Reihenfolge setzen",
      "orderingStop": "Reihenfolge beenden",
      "orderingSave": "Reihenfolge speichern",
      "orderingCancel": "Abbrechen",
      "orderingCol": "Reih.",
      "addressCol": "Adresse / Koordinate",
      "addressFallback": "Koordinate",
      "hideDeleted": "Hide deleted",
      "edit": "Edit",
      "save": "Save",
      "cancel": "Cancel",
      "preview": "Preview",
      "apply": "Apply",
      "geocoding": "Geocoding...",
      "noResult": "No result",
      "suggestions": "Suggestions",
      "noSuggestions": "No suggestions",
      "selectLocation": "Select location",
      "address": "Address",
      "coordinates": "Coordinates",
      "confirm": "Yes"
    },
    "menu": {
      "bins": "Behälter",
      "users": "Benutzer",
      "settings": "Einstellungen",
      "logs": "Logs",
      "sites": "Standorte",
      "fileManagement": "Dateiverwaltung",
      "docs": "Documentation"
    },
    "logs": {
      "title": "Audit Logs",
      "tabUsers": "Benutzer",
      "tabBins": "Behälter",
      "loading": "Lädt...",
      "time": "Zeit",
      "action": "Aktion",
      "entity": "Entität",
      "entityId": "Entität ID",
      "userId": "Benutzer ID",
      "empty": "Keine Daten",
      "notAuthorized": "Nicht berechtigt",
      "detailsTitle": "Details",
      "diffBefore": "Vorher",
      "diffAfter": "Nachher",
      "diffChanged": "Geänderte Felder",
      "diffNoChanges": "Keine Änderungen",
      "close": "Schließen",
      "showRaw": "Rohdaten anzeigen",
      "hideRaw": "Rohdaten verbergen",
      "tabMedia": "Fájlok",
      "entityIdBin": "Bin ID",
      "entityIdSite": "Site ID",
      "settingCol": "Setting",
      "filterTimeFrom": "From",
      "filterTimeTo": "To"
    },
    "bins": {
      "tooltip": {
        "fill": "Füllstand",
        "door": "Tür",
        "battery": "Batterie",
        "batteryVolts": "Batterie (V)",
        "heartbeat": "Lebenszeichen",
        "lastHeartbeat": "Letztes Lebenszeichen"
      },
      "collectionList": "Sammelliste",
      "collectionListTitle": "Druckbare Sammelliste",
      "collectionListGenerate": "Öffnen",
      "collectionListSort": {
        "order": "Standort-Reihenfolge",
        "fill": "Füllstand",
        "mixed": "Gemischt"
      },
      "collectionListUpdatedWithin": "Frisch (Min)",
      "collectionListIncludeUnordered": "Ohne Reihenfolge einschließen",
      "collectionListHint": "Öffnet druckbares HTML in neuem Tab.",
      "map": "Karte",
      "list": "Liste",
      "addNew": "Neuen Behälter hinzufügen",
      "add": "Hinzufügen",
      "listTitle": "Behälterliste",
      "empty": "Noch keine Behälter. Oben hinzufügen.",
      "detailsTab": "Details",
      "form": {
        "identifier": "Bezeichner",
        "identifierPlaceholder": "z.B. BIN-001",
        "latitudePlaceholder": "47.49",
        "longitudePlaceholder": "19.04",
        "add": "Hinzufügen",
        "saving": "Speichern...",
        "errorIdentifierRequired": "Bezeichner erforderlich"
      },
      "details": {
        "mapPreview": "Karten Vorschau",
        "noCoordinates": "Keine Koordinaten",
        "latitude": "Breite",
        "longitude": "Länge",
        "useManual": "Koordinaten manuell setzen",
        "stats": {
          "filling": "Füllstand",
          "state": "Status",
          "battery": "Batterie",
          "solar": "Solar",
          "signal": "Signal",
          "availability": "Verfügbarkeit",
          "unlocked": "Entsperrt",
          "locked": "Gesperrt",
          "signalExcellent": "Ausgezeichnet",
          "signalGood": "Gut",
          "signalWeak": "Schwach"
        },
        "innerTabs": {
          "details": "Details",
          "history": "Verlauf",
          "chart": "Diagramm",
          "settings": "Einstellungen",
          "lock": "Sperreinstellungen",
          "service": "Service",
          "availability": "Verfügbarkeit",
          "report": "Bericht"
        },
        "fields": {
          "serial": "Seriennummer",
          "name": "Name",
          "description": "Beschreibung",
          "installationDate": "Installationsdatum",
          "version": "Version",
          "lastContact": "Letzter Kontakt",
          "lastEmptied": "Zuletzt geleert",
          "district": "Bezirk",
          "location": "Position"
        },
        "edit": "Bearbeiten",
        "editPosition": "Position bearbeiten",
        "dragHint": "Ziehe den Behälter auf der Karte, um neue Koordinaten zu setzen, dann speichern."
      },
      "mapLegend": {
        "title": "Füllstand",
        "low": "< 70%",
        "medium": "70–89%",
        "high": "≥ 90%",
        "noData": "Keine Daten"
      },
      "latch": {
        "open": "Offen",
        "closed": "Geschlossen",
        "actionOpen": "umschalten = Öffnen",
        "actionClose": "umschalten = Schließen",
        "sendOpen": "Öffnen senden",
        "sendClose": "Schließen senden",
        "sending": "Senden..."
      },
      "maintenanceList": "Maintenance list",
      "maintenanceListTitle": "Printable maintenance list",
      "maintenanceListGenerate": "Open",
      "maintenanceListSort": {
        "battery": "Battery voltage"
      },
      "maintenanceListHint": "Open button shows printable HTML in new tab.",
      "selectSiteFirst": "Bitte zuerst einen Standort wählen",
      "delete": "Delete",
      "restore": "Restore",
      "deletedBadge": "deleted",
      "emptyNoSites": "Before adding a bin you must create at least one site."
    },
    "users": {
      "management": "Benutzerverwaltung",
      "users": "Benutzer",
      "addUser": "Benutzer hinzufügen",
      "username": "Benutzername",
      "email": "E-Mail",
      "role": "Rolle",
      "actions": "Aktionen",
      "create": "Erstellen",
      "cancel": "Abbrechen",
      "save": "Speichern",
      "passwordPlaceholder": "Passwort",
      "delete": "Löschen",
      "restore": "Wiederherstellen",
      "deletedBadge": "gelöscht",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "phone": "Telefon",
      "validationMissingFields": "Bitte E-Mail, Passwort, Nachname und Vorname ausfüllen.",
      "passwordTooShort": "Mindestens 8 Zeichen",
      "passwordMismatch": "Passwörter stimmen nicht überein",
      "passwordWeak": "Schwaches Passwort: füge Großbuchstaben und Zahl hinzu",
      "passwordMedium": "Mittel: füge Großbuchstaben und Zahl hinzu",
      "passwordStrong": "Starkes Passwort",
      "edit": "Edit",
      "changePassword": "Change password",
      "newPassword": "New password",
      "confirmPassword": "Confirm password",
      "passwordUpdated": "Password updated",
      "deleteProtectedSuperadmin": "A superadmin felhasználó nem törölhető.",
      "protectedSuperadminBadge": "Szuperadmin (védett)"
    },
    "auth": {
      "login": "Anmelden",
      "register": "Registrieren",
      "email": "Email",
      "password": "Password",
      "haveAccount": "Already have an account?",
      "noAccount": "Don't have an account?",
      "loginHere": "Login here",
      "registerHere": "Register here",
      "username": "Username",
      "unexpectedError": "An unexpected error occurred. Please try again."
    },
    "settings": {
      "title": "Einstellungen",
      "language": "Sprache",
      "selectLanguage": "Sprache wählen",
      "batteryLowThreshold": "Batterie-Untergrenze (V)",
      "batteryLowThresholdHint": "Batterie-Overlay auf der Karte richtet sich nach diesem Grenzwert.",
      "fillGreenThreshold": "Telítettség zöld küszöb (%)",
      "fillYellowThreshold": "Telítettség sárga küszöb (%)",
      "fillRedThreshold": "Telítettség piros küszöb (%)",
      "fillThresholdsHint": "A telítettség színei (zöld/sárga/piros) ezekhez a küszöbökhöz igazodnak.",
      "saved": "Settings saved"
    },
    "media": {
      "title": "Dateiverwaltung",
      "audioTab": "Audiodateien (WAV)",
      "imageTab": "Bilddateien (BMP)",
      "upload": "Hochladen",
      "uploading": "Hochladen...",
      "assign": "Zuweisen",
      "assignBinPlaceholder": "Behälter ID",
      "publish": "Veröffentlichen",
      "publishDisabledHint": "Später verfügbar",
      "fileName": "Dateiname",
      "fileType": "Typ",
      "version": "Version",
      "bin": "Behälter",
      "sizeBytes": "Größe (B)",
      "noFiles": "Keine Dateien",
      "noMediaForBin": "Keine Medien für diesen Behälter.",
      "action": {
        "open": "Öffnen",
        "compression": "Kompression",
        "full": "Voll",
        "notice": "Hinweis",
        "standby": "Bereitschaft"
      },
      "sitesGroup": "Standorte",
      "binsGroup": "Behälter",
      "open": "Open",
      "delete": "Delete",
      "deleteDisabledHint": "Delete coming soon",
      "deleteConfirm": "Are you sure? This cannot be undone.",
      "deleteHint": "Permanently delete file",
      "deleting": "Deleting...",
      "actionColumn": "Action",
      "binColumn": "Bin",
      "allFiles": "All files",
      "bulkActionHint": "Individual actions",
      "actionSelectPlaceholder": "Action...",
      "binSelectPlaceholder": "Bin...",
      "confirmTitle": "Confirmation",
      "confirmPublish": "Are you sure you want to publish this file to the assigned bin?",
      "confirmPublishAll": "Are you sure you want to publish all files?",
      "publishMissingAction": "Select an action for every file",
      "deleteAllConfirm": "Are you sure you want to delete all files?"
    },
    "sites": {
      "title": "Standorte",
      "list": "Standortliste",
      "addNew": "Standort hinzufügen",
      "selectPlaceholder": "Standort wählen",
      "validationSelectSite": "Standort wählen",
      "fields": {
        "code": "Code",
        "name": "Name",
        "address": "Adresse",
        "phone": "Telefon",
        "latitude": "Breite",
        "longitude": "Länge",
        "site": "Standort",
        "coordinates": "Koordinaten"
      },
      "placeholders": {
        "code": "z.B. SITE1",
        "name": "Name",
        "address": "Adresse",
        "phone": "Telefon",
        "latitude": "47.49",
        "longitude": "19.04"
      },
      "form": {
        "code": "Code",
        "name": "Name",
        "address": "Adresse",
        "phone": "Telefon",
        "latitude": "Breite",
        "longitude": "Länge",
        "create": "Erstellen",
        "requiredCode": "Code erforderlich",
        "requiredName": "Name erforderlich"
      },
      "validationCodeRequired": "Code erforderlich",
      "validationAddressChars": "Adresse enthält ungültige Zeichen",
      "validationAddressTooLong": "Adresse zu lang (max 180)",
      "validationAddressNeedStreetNumber": "Adresse muss Straße und Hausnummer enthalten",
      "empty": "Keine Standorte. Erstelle einen.",
      "code": "Code",
      "name": "Name",
      "address": "Adresse",
      "phone": "Telefon"
    },
    "docs": {
      "title": "Documentation",
      "intro": "Overview of the application by user roles.",
      "menu": {
        "title": "Sections"
      },
      "backTop": "Back to top",
      "general": {
        "title": "General Information",
        "purpose": "SmartBin helps operate bins transparently and in real time: it shows current fill level, battery status and lock state, assists with collection planning, and distributes media messages (audio/images).",
        "structure": "The app is straightforward: the left menu gives access to the main features (Bins, Sites, Files, Users, Settings, Logs). In Bins, view map and list with details, charts and history. In Files, manage audio/image files and assign them to bins. Logs shows an audit trail of key operations and events.",
        "features": {
          "mapList": "Map and list: quick overview with color-coded fill, battery and lock indicators.",
          "collection": "Collection list: filter by site and thresholds; printable/exportable.",
          "media": "Media: upload and distribute audio/image files; device acknowledgements (ACK) appear in Logs.",
          "sites": "Sites: manage locations to which bins belong.",
          "users": "Users: add, edit, change passwords; permissions differ by role.",
          "settings": "Settings: language and telemetry thresholds (battery, fill) affecting displayed indicators.",
          "logs": "Logs: auditing of essential system and user actions, with details and period filters."
        },
        "roles": "Roles: users can browse and view; managers and admins can modify, delete and administer the system. Superadmin has system-wide permissions and may remain hidden in some lists.",
        "tips": "Tips: use filters to find quickly; lists can be sorted and exported. If a device is offline/unreachable, indicators reflect that. Errors and acknowledgements are visible in Logs."
      },
      "legend": {
        "title": "Legend",
        "fill": {
          "title": "Fill",
          "green": "Green",
          "yellow": "Yellow",
          "red": "Red",
          "none": "No data"
        },
        "battery": {
          "title": "Battery",
          "ok": "OK",
          "low": "Low"
        },
        "lock": {
          "title": "Lock",
          "closed": "Closed",
          "open": "Open"
        },
        "signal": {
          "title": "Signal",
          "excellent": "Excellent",
          "good": "Good",
          "weak": "Weak"
        },
        "mediaAck": {
          "title": "Media ACK",
          "ok": "OK",
          "fail": "Fail"
        },
        "media": {
          "title": "Media",
          "audio": "Audio",
          "image": "Image"
        },
        "roles": {
          "title": "Roles",
          "superadmin": "Superadmin",
          "admin": "Admin",
          "manager": "Manager",
          "user": "User"
        },
        "sites": {
          "title": "Sites",
          "code": "Code",
          "location": "Location"
        }
      },
      "bins": {
        "title": "Bins",
        "overview": "In the Bins menu you can view the map, list and selected bin details.",
        "steps1": "Click “Bins” in the left menu. Use the top tabs to switch between Map and List. On the map click an icon for details; in the list click a row.",
        "map": "Map: color-coded icons (green/yellow/red), battery and lock overlays.",
        "list": "List: fill level progress bar, battery voltage, lock state, sorting.",
        "details": "Details: mini map, status cards, charts, history.",
        "manage": "Bin management: add, edit, delete, ordering, collection list generation.",
        "steps2": "New bin: top-right “+ New bin”. Edit: open details → “Edit”. Delete: click the “Delete” icon in the row.",
        "order": "Ordering: use Up/Down controls or drag in the list; save with “Save order”.",
        "collection": "Collection list: set filters (site, fill), then “Generate list”; export to PDF/CSV.",
        "userView": "As a user you can view the map and list, and details like fill level and status."
      },
      "sites": {
        "title": "Sites",
        "overview": "Manage and view sites."
      },
      "files": {
        "title": "Files",
        "overview": "Manage audio and image files, assign to bins.",
        "steps": "Open “Files”. Upload by dragging or clicking “Upload”. To assign, pick a bin then click “Assign” on the file."
      },
      "users": {
        "title": "Users",
        "overview": "Manage users: create, edit, delete, change password.",
        "steps": "Go to “Users”. New user: “+ New user”. Edit: “Edit” icon in the row. Role: choose from dropdown."
      },
      "settings": {
        "title": "Settings",
        "overview": "Global settings: language, telemetry thresholds (battery, fill), audit logging.",
        "steps": "Go to “Settings”. In Telemetry set battery low threshold and fill thresholds, then save.",
        "tips": "Tip: hover (i) icons for more info. If green upper ≤ red lower, Save may be disabled."
      },
      "admin": {
        "title": "Admin features",
        "overview": "Audit logs, role management, system configuration and advanced settings."
      },
      "logs": {
        "title": "Logs",
        "overview": "The Logs menu shows audit records and events. Filter by time, entity and action; details show before/after states of changes.",
        "mediaAck": "Media (image/audio) delivery acknowledgements (ACK) are highlighted and appear instantly via realtime events."
      }
    },
    "confirm": {
      "titleDelete": "Delete User",
      "titleRestore": "Restore User",
      "messageDelete": "Are you sure you want to soft delete this user? They will not be able to log in until restored.",
      "messageRestore": "Restore this user? They will be able to log in again.",
      "proceed": "Yes",
      "cancel": "Cancel"
    },
    "confirmBin": {
      "titleDelete": "Delete Bin",
      "titleRestore": "Restore Bin",
      "messageDelete": "Are you sure you want to soft delete this bin? It will disappear from the map until restored.",
      "messageRestore": "Restore this bin? It will appear again on the map.",
      "proceed": "Yes",
      "cancel": "Cancel"
    },
  },
  "pl": {
    "appTitle": "Panel SmartBin",
    "logout": "Wyloguj",
    "common": {
      "refresh": "Odśwież",
      "saving": "Zapisywanie...",
      "all": "Wszystkie",
      "orderingMode": "Tryb kolejności",
      "orderingStart": "Ustaw kolejność",
      "orderingStop": "Zakończ",
      "orderingSave": "Zapisz kolejność",
      "orderingCancel": "Anuluj",
      "orderingCol": "Kolej.",
      "addressCol": "Adres / Współrzędne",
      "addressFallback": "współrzędna",
      "hideDeleted": "Hide deleted",
      "edit": "Edit",
      "save": "Save",
      "cancel": "Cancel",
      "preview": "Preview",
      "apply": "Apply",
      "geocoding": "Geocoding...",
      "noResult": "No result",
      "suggestions": "Suggestions",
      "noSuggestions": "No suggestions",
      "selectLocation": "Select location",
      "address": "Address",
      "coordinates": "Coordinates",
      "confirm": "Yes"
    },
    "menu": {
      "bins": "Pojemniki",
      "users": "Użytkownicy",
      "settings": "Ustawienia",
      "logs": "Logi",
      "sites": "Lokalizacje",
      "fileManagement": "Pliki",
      "docs": "Documentation"
    },
    "bins": {
      "tooltip": {
        "fill": "Napełnienie",
        "door": "Drzwi",
        "battery": "Bateria",
        "batteryVolts": "Bateria (V)",
        "heartbeat": "Sygnał życia",
        "lastHeartbeat": "Ostatni sygnał życia"
      },
      "collectionList": "Lista odbioru",
      "collectionListTitle": "Drukowalna lista odbioru",
      "collectionListGenerate": "Otwórz",
      "collectionListSort": {
        "order": "Kolejność lok.",
        "fill": "Napełnienie",
        "mixed": "Mieszane"
      },
      "collectionListUpdatedWithin": "Świeże (min)",
      "collectionListIncludeUnordered": "Uwzględnij bez kolejności",
      "collectionListHint": "Otwiera drukowalne HTML w nowej karcie.",
      "map": "Mapa",
      "list": "Lista",
      "addNew": "Dodaj pojemnik",
      "add": "Dodaj",
      "listTitle": "Lista pojemników",
      "empty": "Brak pojemników. Dodaj powyżej.",
      "detailsTab": "Szczegóły",
      "form": {
        "identifier": "Identyfikator",
        "identifierPlaceholder": "np. BIN-001",
        "latitudePlaceholder": "47.49",
        "longitudePlaceholder": "19.04",
        "add": "Dodaj",
        "saving": "Zapisywanie...",
        "errorIdentifierRequired": "Identyfikator wymagany"
      },
      "details": {
        "mapPreview": "Podgląd mapy",
        "noCoordinates": "Brak współrzędnych",
        "latitude": "Szerokość",
        "longitude": "Długość",
        "useManual": "Ręczne współrzędne",
        "stats": {
          "filling": "Napełnienie",
          "state": "Stan",
          "battery": "Bateria",
          "solar": "Solar",
          "signal": "Sygnał",
          "availability": "Dostępność",
          "unlocked": "Odblokowany",
          "locked": "Zablokowany",
          "signalExcellent": "Doskonale",
          "signalGood": "Dobrze",
          "signalWeak": "Słaby"
        },
        "innerTabs": {
          "details": "Szczegóły",
          "history": "Historia",
          "chart": "Wykres",
          "settings": "Ustawienia",
          "lock": "Zamek",
          "service": "Serwis",
          "availability": "Dostępność",
          "report": "Raport"
        },
        "fields": {
          "serial": "Numer seryjny",
          "name": "Nazwa",
          "description": "Opis",
          "installationDate": "Data instalacji",
          "version": "Wersja",
          "lastContact": "Ostatni kontakt",
          "lastEmptied": "Ostatnie opróżnienie",
          "district": "Rejon",
          "location": "Pozycja"
        },
        "edit": "Edytuj",
        "editPosition": "Edytuj pozycję",
        "dragHint": "Przeciągnij pojemnik na mapie, aby ustawić nowe współrzędne, a następnie zapisz."
      },
      "mapLegend": {
        "title": "Napełnienie",
        "low": "< 70%",
        "medium": "70–89%",
        "high": "≥ 90%",
        "noData": "Brak danych"
      },
      "latch": {
        "open": "Otwarte",
        "closed": "Zamknięte",
        "actionOpen": "przełącz = Otwarcie",
        "actionClose": "przełącz = Zamknięcie",
        "sendOpen": "Wyślij Otwarcie",
        "sendClose": "Wyślij Zamknięcie",
        "sending": "Wysyłanie..."
      },
      "maintenanceList": "Maintenance list",
      "maintenanceListTitle": "Printable maintenance list",
      "maintenanceListGenerate": "Open",
      "maintenanceListSort": {
        "battery": "Battery voltage"
      },
      "maintenanceListHint": "Open button shows printable HTML in new tab.",
      "selectSiteFirst": "Najpierw wybierz lokalizację",
      "delete": "Delete",
      "restore": "Restore",
      "deletedBadge": "deleted",
      "emptyNoSites": "Before adding a bin you must create at least one site."
    },
    "logs": {
      "title": "Logi audytu",
      "tabUsers": "Użytkownicy",
      "tabBins": "Pojemniki",
      "loading": "Ładowanie...",
      "time": "Czas",
      "action": "Akcja",
      "entity": "Encja",
      "entityId": "ID encji",
      "userId": "ID użytkownika",
      "empty": "Brak danych",
      "notAuthorized": "Brak uprawnień",
      "detailsTitle": "Szczegóły",
      "diffBefore": "Przed",
      "diffAfter": "Po",
      "diffChanged": "Zm. pola",
      "diffNoChanges": "Brak zmian",
      "close": "Zamknij",
      "showRaw": "Pokaż surowe",
      "hideRaw": "Ukryj surowe",
      "tabMedia": "Fájlok",
      "entityIdBin": "Bin ID",
      "entityIdSite": "Site ID",
      "settingCol": "Setting",
      "filterTimeFrom": "From",
      "filterTimeTo": "To"
    },
    "users": {
      "management": "Zarządzanie użytkownikami",
      "users": "Użytkownicy",
      "addUser": "Dodaj użytkownika",
      "username": "Nazwa użytkownika",
      "email": "Email",
      "role": "Rola",
      "actions": "Akcje",
      "create": "Utwórz",
      "cancel": "Anuluj",
      "save": "Zapisz",
      "passwordPlaceholder": "hasło",
      "delete": "Usuń",
      "restore": "Przywróć",
      "deletedBadge": "usunięty",
      "firstName": "Imię",
      "lastName": "Nazwisko",
      "phone": "Telefon",
      "validationMissingFields": "Wypełnij email, hasło, nazwisko i imię.",
      "edit": "Edit",
      "changePassword": "Change password",
      "newPassword": "New password",
      "confirmPassword": "Confirm password",
      "passwordUpdated": "Password updated",
      "deleteProtectedSuperadmin": "A superadmin felhasználó nem törölhető.",
      "protectedSuperadminBadge": "Szuperadmin (védett)",
      "passwordTooShort": "Minimum 8 characters",
      "passwordMismatch": "Passwords do not match",
      "passwordWeak": "Weak password: add uppercase and number",
      "passwordMedium": "Medium: add uppercase and number",
      "passwordStrong": "Strong password"
    },
    "confirm": {
      "titleDelete": "Usuń użytkownika",
      "titleRestore": "Przywróć użytkownika",
      "messageDelete": "Na pewno usunąć (soft) użytkownika? Nie zaloguje się do czasu przywrócenia.",
      "messageRestore": "Przywrócić tego użytkownika? Znów się zaloguje.",
      "proceed": "Tak",
      "cancel": "Anuluj"
    },
    "auth": {
      "login": "Logowanie",
      "register": "Rejestracja",
      "email": "Email",
      "password": "Hasło",
      "haveAccount": "Masz konto?",
      "noAccount": "Nie masz konta?",
      "loginHere": "Zaloguj się",
      "registerHere": "Zarejestruj się",
      "username": "Nazwa użytkownika",
      "unexpectedError": "Wystąpił nieoczekiwany błąd. Spróbuj ponownie."
    },
    "settings": {
      "title": "Ustawienia",
      "language": "Język",
      "selectLanguage": "Wybierz język",
      "batteryLowThreshold": "Battery low threshold (V)",
      "batteryLowThresholdHint": "Battery overlay on map follows this threshold.",
      "fillGreenThreshold": "Telítettség zöld küszöb (%)",
      "fillYellowThreshold": "Telítettség sárga küszöb (%)",
      "fillRedThreshold": "Telítettség piros küszöb (%)",
      "fillThresholdsHint": "A telítettség színei (zöld/sárga/piros) ezekhez a küszöbökhöz igazodnak.",
      "saved": "Settings saved"
    },
    "media": {
      "title": "Zarządzanie plikami",
      "audioTab": "Pliki audio (WAV)",
      "imageTab": "Pliki obrazów (BMP)",
      "upload": "Prześlij",
      "uploading": "Przesyłanie...",
      "assign": "Przypisz",
      "assignBinPlaceholder": "ID pojemnika",
      "publish": "Publikuj",
      "publishDisabledHint": "Wkrótce",
      "fileName": "Nazwa pliku",
      "fileType": "Typ",
      "version": "Wersja",
      "bin": "Pojemnik",
      "sizeBytes": "Rozmiar (B)",
      "noFiles": "Brak plików",
      "noMediaForBin": "Brak mediów dla tego pojemnika.",
      "action": {
        "open": "Otwórz",
        "compression": "Kompresja",
        "full": "Pełny",
        "notice": "Powiadomienie",
        "standby": "Czuwanie"
      },
      "sitesGroup": "Lokalizacje",
      "binsGroup": "Pojemniki",
      "open": "Open",
      "delete": "Delete",
      "deleteDisabledHint": "Delete coming soon",
      "deleteConfirm": "Are you sure? This cannot be undone.",
      "deleteHint": "Permanently delete file",
      "deleting": "Deleting...",
      "actionColumn": "Action",
      "binColumn": "Bin",
      "allFiles": "All files",
      "bulkActionHint": "Individual actions",
      "actionSelectPlaceholder": "Action...",
      "binSelectPlaceholder": "Bin...",
      "confirmTitle": "Confirmation",
      "confirmPublish": "Are you sure you want to publish this file to the assigned bin?",
      "confirmPublishAll": "Are you sure you want to publish all files?",
      "publishMissingAction": "Select an action for every file",
      "deleteAllConfirm": "Are you sure you want to delete all files?"
    },
    "sites": {
      "title": "Lokalizacje",
      "list": "Lista lokalizacji",
      "addNew": "Dodaj lokalizację",
      "selectPlaceholder": "Wybierz lokalizację",
      "validationSelectSite": "Wybierz lokalizację",
      "fields": {
        "code": "Kod",
        "name": "Nazwa",
        "address": "Adres",
        "phone": "Telefon",
        "latitude": "Szer.",
        "longitude": "Dł.",
        "site": "Lokalizacja",
        "coordinates": "Współrzędne"
      },
      "placeholders": {
        "code": "np. SITE1",
        "name": "Nazwa",
        "address": "Adres",
        "phone": "Telefon",
        "latitude": "47.49",
        "longitude": "19.04"
      },
      "form": {
        "code": "Kod",
        "name": "Nazwa",
        "address": "Adres",
        "phone": "Telefon",
        "latitude": "Szer.",
        "longitude": "Dł.",
        "create": "Utwórz",
        "requiredCode": "Kod wymagany",
        "requiredName": "Nazwa wymagana"
      },
      "validationCodeRequired": "Kod wymagany",
      "validationAddressChars": "Adres zawiera nieprawidłowe znaki",
      "validationAddressTooLong": "Adres za długi (max 180)",
      "validationAddressNeedStreetNumber": "Adres musi zawierać ulicę i numer",
      "empty": "Brak lokalizacji. Utwórz nową.",
      "code": "Kod",
      "name": "Nazwa",
      "address": "Adres",
      "phone": "Telefon"
    },
    "docs": {
      "title": "Documentation",
      "intro": "Overview of the application by user roles.",
      "menu": {
        "title": "Sections"
      },
      "backTop": "Back to top",
      "general": {
        "title": "General Information",
        "purpose": "SmartBin helps operate bins transparently and in real time: it shows current fill level, battery status and lock state, assists with collection planning, and distributes media messages (audio/images).",
        "structure": "The app is straightforward: the left menu gives access to the main features (Bins, Sites, Files, Users, Settings, Logs). In Bins, view map and list with details, charts and history. In Files, manage audio/image files and assign them to bins. Logs shows an audit trail of key operations and events.",
        "features": {
          "mapList": "Map and list: quick overview with color-coded fill, battery and lock indicators.",
          "collection": "Collection list: filter by site and thresholds; printable/exportable.",
          "media": "Media: upload and distribute audio/image files; device acknowledgements (ACK) appear in Logs.",
          "sites": "Sites: manage locations to which bins belong.",
          "users": "Users: add, edit, change passwords; permissions differ by role.",
          "settings": "Settings: language and telemetry thresholds (battery, fill) affecting displayed indicators.",
          "logs": "Logs: auditing of essential system and user actions, with details and period filters."
        },
        "roles": "Roles: users can browse and view; managers and admins can modify, delete and administer the system. Superadmin has system-wide permissions and may remain hidden in some lists.",
        "tips": "Tips: use filters to find quickly; lists can be sorted and exported. If a device is offline/unreachable, indicators reflect that. Errors and acknowledgements are visible in Logs."
      },
      "legend": {
        "title": "Legend",
        "fill": {
          "title": "Fill",
          "green": "Green",
          "yellow": "Yellow",
          "red": "Red",
          "none": "No data"
        },
        "battery": {
          "title": "Battery",
          "ok": "OK",
          "low": "Low"
        },
        "lock": {
          "title": "Lock",
          "closed": "Closed",
          "open": "Open"
        },
        "signal": {
          "title": "Signal",
          "excellent": "Excellent",
          "good": "Good",
          "weak": "Weak"
        },
        "mediaAck": {
          "title": "Media ACK",
          "ok": "OK",
          "fail": "Fail"
        },
        "media": {
          "title": "Media",
          "audio": "Audio",
          "image": "Image"
        },
        "roles": {
          "title": "Roles",
          "superadmin": "Superadmin",
          "admin": "Admin",
          "manager": "Manager",
          "user": "User"
        },
        "sites": {
          "title": "Sites",
          "code": "Code",
          "location": "Location"
        }
      },
      "bins": {
        "title": "Bins",
        "overview": "In the Bins menu you can view the map, list and selected bin details.",
        "steps1": "Click “Bins” in the left menu. Use the top tabs to switch between Map and List. On the map click an icon for details; in the list click a row.",
        "map": "Map: color-coded icons (green/yellow/red), battery and lock overlays.",
        "list": "List: fill level progress bar, battery voltage, lock state, sorting.",
        "details": "Details: mini map, status cards, charts, history.",
        "manage": "Bin management: add, edit, delete, ordering, collection list generation.",
        "steps2": "New bin: top-right “+ New bin”. Edit: open details → “Edit”. Delete: click the “Delete” icon in the row.",
        "order": "Ordering: use Up/Down controls or drag in the list; save with “Save order”.",
        "collection": "Collection list: set filters (site, fill), then “Generate list”; export to PDF/CSV.",
        "userView": "As a user you can view the map and list, and details like fill level and status."
      },
      "sites": {
        "title": "Sites",
        "overview": "Manage and view sites."
      },
      "files": {
        "title": "Files",
        "overview": "Manage audio and image files, assign to bins.",
        "steps": "Open “Files”. Upload by dragging or clicking “Upload”. To assign, pick a bin then click “Assign” on the file."
      },
      "users": {
        "title": "Users",
        "overview": "Manage users: create, edit, delete, change password.",
        "steps": "Go to “Users”. New user: “+ New user”. Edit: “Edit” icon in the row. Role: choose from dropdown."
      },
      "settings": {
        "title": "Settings",
        "overview": "Global settings: language, telemetry thresholds (battery, fill), audit logging.",
        "steps": "Go to “Settings”. In Telemetry set battery low threshold and fill thresholds, then save.",
        "tips": "Tip: hover (i) icons for more info. If green upper ≤ red lower, Save may be disabled."
      },
      "admin": {
        "title": "Admin features",
        "overview": "Audit logs, role management, system configuration and advanced settings."
      },
      "logs": {
        "title": "Logs",
        "overview": "The Logs menu shows audit records and events. Filter by time, entity and action; details show before/after states of changes.",
        "mediaAck": "Media (image/audio) delivery acknowledgements (ACK) are highlighted and appear instantly via realtime events."
      }
    },
    "confirmBin": {
      "titleDelete": "Delete Bin",
      "titleRestore": "Restore Bin",
      "messageDelete": "Are you sure you want to soft delete this bin? It will disappear from the map until restored.",
      "messageRestore": "Restore this bin? It will appear again on the map.",
      "proceed": "Yes",
      "cancel": "Cancel"
    }
  },
  "cs": {
    "appTitle": "SmartBin Dashboard",
    "logout": "Odhlásit",
    "common": {
      "refresh": "Obnovit",
      "saving": "Ukládání...",
      "all": "Vše",
      "orderingMode": "Režim pořadí",
      "orderingStart": "Nastavit pořadí",
      "orderingStop": "Konec pořadí",
      "orderingSave": "Uložit pořadí",
      "orderingCancel": "Zrušit",
      "orderingCol": "Poř.",
      "addressCol": "Adresa / Souřadnice",
      "addressFallback": "souřadnice",
      "hideDeleted": "Hide deleted",
      "edit": "Edit",
      "save": "Save",
      "cancel": "Cancel",
      "preview": "Preview",
      "apply": "Apply",
      "geocoding": "Geocoding...",
      "noResult": "No result",
      "suggestions": "Suggestions",
      "noSuggestions": "No suggestions",
      "selectLocation": "Select location",
      "address": "Address",
      "coordinates": "Coordinates",
      "confirm": "Yes"
    },
    "menu": {
      "bins": "Koše",
      "users": "Uživatelé",
      "settings": "Nastavení",
      "logs": "Logy",
      "sites": "Provozovny",
      "fileManagement": "Soubory",
      "docs": "Documentation"
    },
    "bins": {
      "tooltip": {
        "fill": "Zaplnění",
        "door": "Dveře",
        "battery": "Baterie",
        "batteryVolts": "Baterie (V)",
        "heartbeat": "Životní signál",
        "lastHeartbeat": "Poslední životní signál"
      },
      "collectionList": "Seznam vývozu",
      "collectionListTitle": "Tisknutelný seznam vývozu",
      "collectionListGenerate": "Otevřít",
      "collectionListSort": {
        "order": "Pořadí provoz.",
        "fill": "Zaplnění",
        "mixed": "Smíšené"
      },
      "collectionListUpdatedWithin": "Čerstvé (min)",
      "collectionListIncludeUnordered": "Včetně bez pořadí",
      "collectionListHint": "Otevře tisknutelné HTML v nové kartě.",
      "map": "Mapa",
      "list": "Seznam",
      "addNew": "Přidat koš",
      "add": "Přidat",
      "listTitle": "Seznam košů",
      "empty": "Žádné koše. Přidejte výše.",
      "detailsTab": "Detaily",
      "form": {
        "identifier": "Identifikátor",
        "identifierPlaceholder": "např. BIN-001",
        "latitudePlaceholder": "47.49",
        "longitudePlaceholder": "19.04",
        "add": "Přidat",
        "saving": "Ukládání...",
        "errorIdentifierRequired": "Identifikátor je povinný"
      },
      "details": {
        "mapPreview": "Náhled mapy",
        "noCoordinates": "Žádné souřadnice",
        "latitude": "Šířka",
        "longitude": "Délka",
        "useManual": "Ruční souřadnice",
        "stats": {
          "filling": "Zaplnění",
          "state": "Stav",
          "battery": "Baterie",
          "solar": "Solární",
          "signal": "Signál",
          "availability": "Dostupnost",
          "unlocked": "Odemčeno",
          "locked": "Zamčeno",
          "signalExcellent": "Výborný",
          "signalGood": "Dobrý",
          "signalWeak": "Slabý"
        },
        "innerTabs": {
          "details": "Detaily",
          "history": "Historie",
          "chart": "Graf",
          "settings": "Nastavení",
          "lock": "Zámek",
          "service": "Servis",
          "availability": "Dostupnost",
          "report": "Report"
        },
        "fields": {
          "serial": "Sériové číslo",
          "name": "Název",
          "description": "Popis",
          "installationDate": "Datum instalace",
          "version": "Verze",
          "lastContact": "Poslední kontakt",
          "lastEmptied": "Poslední vyprázdnění",
          "district": "Obvod",
          "location": "Pozice"
        },
        "edit": "Upravit",
        "editPosition": "Upravit pozici",
        "dragHint": "Přetáhněte koš na mapě pro nastavení nové pozice a poté uložte."
      },
      "mapLegend": {
        "title": "Zaplnění",
        "low": "< 70%",
        "medium": "70–89%",
        "high": "≥ 90%",
        "noData": "Žádná data"
      },
      "latch": {
        "open": "Otevřeno",
        "closed": "Zavřeno",
        "actionOpen": "přepnout = Otevřít",
        "actionClose": "přepnout = Zavřít",
        "sendOpen": "Odeslat Otevřít",
        "sendClose": "Odeslat Zavřít",
        "sending": "Odesílání..."
      },
      "maintenanceList": "Maintenance list",
      "maintenanceListTitle": "Printable maintenance list",
      "maintenanceListGenerate": "Open",
      "maintenanceListSort": {
        "battery": "Battery voltage"
      },
      "maintenanceListHint": "Open button shows printable HTML in new tab.",
      "selectSiteFirst": "Nejprve vyberte lokalitu",
      "delete": "Delete",
      "restore": "Restore",
      "deletedBadge": "deleted",
      "emptyNoSites": "Before adding a bin you must create at least one site."
    },
    "logs": {
      "title": "Audit logy",
      "tabUsers": "Uživatelé",
      "tabBins": "Koše",
      "loading": "Načítání...",
      "time": "Čas",
      "action": "Akce",
      "entity": "Entita",
      "entityId": "Entita ID",
      "userId": "Uživatel ID",
      "empty": "Žádná data",
      "notAuthorized": "Bez oprávnění",
      "detailsTitle": "Detaily",
      "diffBefore": "Před",
      "diffAfter": "Po",
      "diffChanged": "Změněná pole",
      "diffNoChanges": "Žádné změny",
      "close": "Zavřít",
      "showRaw": "Zobrazit raw",
      "hideRaw": "Skrýt raw",
      "tabMedia": "Fájlok",
      "entityIdBin": "Bin ID",
      "entityIdSite": "Site ID",
      "settingCol": "Setting",
      "filterTimeFrom": "From",
      "filterTimeTo": "To"
    },
    "users": {
      "management": "Správa uživatelů",
      "users": "Uživatelé",
      "addUser": "Přidat uživatele",
      "username": "Uživatelské jméno",
      "email": "E-mail",
      "role": "Role",
      "actions": "Akce",
      "create": "Vytvořit",
      "cancel": "Zrušit",
      "save": "Uložit",
      "passwordPlaceholder": "heslo",
      "delete": "Smazat",
      "restore": "Obnovit",
      "deletedBadge": "smazán",
      "firstName": "Jméno",
      "lastName": "Příjmení",
      "phone": "Telefon",
      "validationMissingFields": "Vyplňte email, heslo, příjmení a jméno.",
      "edit": "Edit",
      "changePassword": "Change password",
      "newPassword": "New password",
      "confirmPassword": "Confirm password",
      "passwordUpdated": "Password updated",
      "deleteProtectedSuperadmin": "A superadmin felhasználó nem törölhető.",
      "protectedSuperadminBadge": "Szuperadmin (védett)",
      "passwordTooShort": "Minimum 8 characters",
      "passwordMismatch": "Passwords do not match",
      "passwordWeak": "Weak password: add uppercase and number",
      "passwordMedium": "Medium: add uppercase and number",
      "passwordStrong": "Strong password"
    },
    "confirm": {
      "titleDelete": "Smazat uživatele",
      "titleRestore": "Obnovit uživatele",
      "messageDelete": "Opravdu soft smazat uživatele? Nezaloguje se, dokud neobnovíte.",
      "messageRestore": "Obnovit uživatele? Znovu se přihlásí.",
      "proceed": "Ano",
      "cancel": "Zrušit"
    },
    "auth": {
      "login": "Přihlášení",
      "register": "Registrace",
      "email": "E-mail",
      "password": "Heslo",
      "haveAccount": "Máte účet?",
      "noAccount": "Nemáte účet?",
      "loginHere": "Přihlásit zde",
      "registerHere": "Registrovat zde",
      "username": "Uživatelské jméno",
      "unexpectedError": "Došlo k neočekávané chybě. Zkuste znovu."
    },
    "settings": {
      "title": "Nastavení",
      "language": "Jazyk",
      "selectLanguage": "Vyberte jazyk",
      "batteryLowThreshold": "Battery low threshold (V)",
      "batteryLowThresholdHint": "Battery overlay on map follows this threshold.",
      "fillGreenThreshold": "Telítettség zöld küszöb (%)",
      "fillYellowThreshold": "Telítettség sárga küszöb (%)",
      "fillRedThreshold": "Telítettség piros küszöb (%)",
      "fillThresholdsHint": "A telítettség színei (zöld/sárga/piros) ezekhez a küszöbökhöz igazodnak.",
      "saved": "Settings saved"
    },
    "media": {
      "title": "Správa souborů",
      "audioTab": "Audio soubory (WAV)",
      "imageTab": "Obrázky (BMP)",
      "upload": "Nahrát",
      "uploading": "Nahrávání...",
      "assign": "Přiřadit",
      "assignBinPlaceholder": "ID koše",
      "publish": "Publikovat",
      "publishDisabledHint": "Později",
      "fileName": "Název souboru",
      "fileType": "Typ",
      "version": "Verze",
      "bin": "Koš",
      "sizeBytes": "Velikost (B)",
      "noFiles": "Žádné soubory",
      "noMediaForBin": "Žádná média pro tento koš.",
      "action": {
        "open": "Otevřít",
        "compression": "Komprese",
        "full": "Plný",
        "notice": "Oznámení",
        "standby": "Pohotovost"
      },
      "sitesGroup": "Provozovny",
      "binsGroup": "Koše",
      "open": "Open",
      "delete": "Delete",
      "deleteDisabledHint": "Delete coming soon",
      "deleteConfirm": "Are you sure? This cannot be undone.",
      "deleteHint": "Permanently delete file",
      "deleting": "Deleting...",
      "actionColumn": "Action",
      "binColumn": "Bin",
      "allFiles": "All files",
      "bulkActionHint": "Individual actions",
      "actionSelectPlaceholder": "Action...",
      "binSelectPlaceholder": "Bin...",
      "confirmTitle": "Confirmation",
      "confirmPublish": "Are you sure you want to publish this file to the assigned bin?",
      "confirmPublishAll": "Are you sure you want to publish all files?",
      "publishMissingAction": "Select an action for every file",
      "deleteAllConfirm": "Are you sure you want to delete all files?"
    },
    "sites": {
      "title": "Provozovny",
      "list": "Seznam provozoven",
      "addNew": "Přidat provozovnu",
      "selectPlaceholder": "Vyberte provozovnu",
      "validationSelectSite": "Vyberte provozovnu",
      "fields": {
        "code": "Kód",
        "name": "Název",
        "address": "Adresa",
        "phone": "Telefon",
        "latitude": "Šířka",
        "longitude": "Délka",
        "site": "Provozovna",
        "coordinates": "Souřadnice"
      },
      "placeholders": {
        "code": "např. SITE1",
        "name": "Název",
        "address": "Adresa",
        "phone": "Telefon",
        "latitude": "47.49",
        "longitude": "19.04"
      },
      "form": {
        "code": "Kód",
        "name": "Název",
        "address": "Adresa",
        "phone": "Telefon",
        "latitude": "Šířka",
        "longitude": "Délka",
        "create": "Vytvořit",
        "requiredCode": "Kód je povinný",
        "requiredName": "Název je povinný"
      },
      "validationCodeRequired": "Kód je povinný",
      "validationAddressChars": "Adresa obsahuje neplatné znaky",
      "validationAddressTooLong": "Adresa je příliš dlouhá (max 180)",
      "validationAddressNeedStreetNumber": "Adresa musí obsahovat ulici a číslo",
      "empty": "Žádné provozovny. Přidejte jednu.",
      "code": "Kód",
      "name": "Název",
      "address": "Adresa",
      "phone": "Telefon"
    },
    "docs": {
      "title": "Documentation",
      "intro": "Overview of the application by user roles.",
      "menu": {
        "title": "Sections"
      },
      "backTop": "Back to top",
      "general": {
        "title": "General Information",
        "purpose": "SmartBin helps operate bins transparently and in real time: it shows current fill level, battery status and lock state, assists with collection planning, and distributes media messages (audio/images).",
        "structure": "The app is straightforward: the left menu gives access to the main features (Bins, Sites, Files, Users, Settings, Logs). In Bins, view map and list with details, charts and history. In Files, manage audio/image files and assign them to bins. Logs shows an audit trail of key operations and events.",
        "features": {
          "mapList": "Map and list: quick overview with color-coded fill, battery and lock indicators.",
          "collection": "Collection list: filter by site and thresholds; printable/exportable.",
          "media": "Media: upload and distribute audio/image files; device acknowledgements (ACK) appear in Logs.",
          "sites": "Sites: manage locations to which bins belong.",
          "users": "Users: add, edit, change passwords; permissions differ by role.",
          "settings": "Settings: language and telemetry thresholds (battery, fill) affecting displayed indicators.",
          "logs": "Logs: auditing of essential system and user actions, with details and period filters."
        },
        "roles": "Roles: users can browse and view; managers and admins can modify, delete and administer the system. Superadmin has system-wide permissions and may remain hidden in some lists.",
        "tips": "Tips: use filters to find quickly; lists can be sorted and exported. If a device is offline/unreachable, indicators reflect that. Errors and acknowledgements are visible in Logs."
      },
      "legend": {
        "title": "Legend",
        "fill": {
          "title": "Fill",
          "green": "Green",
          "yellow": "Yellow",
          "red": "Red",
          "none": "No data"
        },
        "battery": {
          "title": "Battery",
          "ok": "OK",
          "low": "Low"
        },
        "lock": {
          "title": "Lock",
          "closed": "Closed",
          "open": "Open"
        },
        "signal": {
          "title": "Signal",
          "excellent": "Excellent",
          "good": "Good",
          "weak": "Weak"
        },
        "mediaAck": {
          "title": "Media ACK",
          "ok": "OK",
          "fail": "Fail"
        },
        "media": {
          "title": "Media",
          "audio": "Audio",
          "image": "Image"
        },
        "roles": {
          "title": "Roles",
          "superadmin": "Superadmin",
          "admin": "Admin",
          "manager": "Manager",
          "user": "User"
        },
        "sites": {
          "title": "Sites",
          "code": "Code",
          "location": "Location"
        }
      },
      "bins": {
        "title": "Bins",
        "overview": "In the Bins menu you can view the map, list and selected bin details.",
        "steps1": "Click “Bins” in the left menu. Use the top tabs to switch between Map and List. On the map click an icon for details; in the list click a row.",
        "map": "Map: color-coded icons (green/yellow/red), battery and lock overlays.",
        "list": "List: fill level progress bar, battery voltage, lock state, sorting.",
        "details": "Details: mini map, status cards, charts, history.",
        "manage": "Bin management: add, edit, delete, ordering, collection list generation.",
        "steps2": "New bin: top-right “+ New bin”. Edit: open details → “Edit”. Delete: click the “Delete” icon in the row.",
        "order": "Ordering: use Up/Down controls or drag in the list; save with “Save order”.",
        "collection": "Collection list: set filters (site, fill), then “Generate list”; export to PDF/CSV.",
        "userView": "As a user you can view the map and list, and details like fill level and status."
      },
      "sites": {
        "title": "Sites",
        "overview": "Manage and view sites."
      },
      "files": {
        "title": "Files",
        "overview": "Manage audio and image files, assign to bins.",
        "steps": "Open “Files”. Upload by dragging or clicking “Upload”. To assign, pick a bin then click “Assign” on the file."
      },
      "users": {
        "title": "Users",
        "overview": "Manage users: create, edit, delete, change password.",
        "steps": "Go to “Users”. New user: “+ New user”. Edit: “Edit” icon in the row. Role: choose from dropdown."
      },
      "settings": {
        "title": "Settings",
        "overview": "Global settings: language, telemetry thresholds (battery, fill), audit logging.",
        "steps": "Go to “Settings”. In Telemetry set battery low threshold and fill thresholds, then save.",
        "tips": "Tip: hover (i) icons for more info. If green upper ≤ red lower, Save may be disabled."
      },
      "admin": {
        "title": "Admin features",
        "overview": "Audit logs, role management, system configuration and advanced settings."
      },
      "logs": {
        "title": "Logs",
        "overview": "The Logs menu shows audit records and events. Filter by time, entity and action; details show before/after states of changes.",
        "mediaAck": "Media (image/audio) delivery acknowledgements (ACK) are highlighted and appear instantly via realtime events."
      }
    },
    "confirmBin": {
      "titleDelete": "Delete Bin",
      "titleRestore": "Restore Bin",
      "messageDelete": "Are you sure you want to soft delete this bin? It will disappear from the map until restored.",
      "messageRestore": "Restore this bin? It will appear again on the map.",
      "proceed": "Yes",
      "cancel": "Cancel"
    }
  },
  "sk": {
    "appTitle": "SmartBin Panel",
    "logout": "Odhlásiť",
    "common": {
      "refresh": "Obnoviť",
      "saving": "Ukladám...",
      "all": "Všetky",
      "orderingMode": "Režim poradia",
      "orderingStart": "Nastaviť poradie",
      "orderingStop": "Koniec poradia",
      "orderingSave": "Uložiť poradie",
      "orderingCancel": "Zrušiť",
      "orderingCol": "Por.",
      "addressCol": "Adresa / Súradnice",
      "addressFallback": "súradnica",
      "hideDeleted": "Hide deleted",
      "edit": "Edit",
      "save": "Save",
      "cancel": "Cancel",
      "preview": "Preview",
      "apply": "Apply",
      "geocoding": "Geocoding...",
      "noResult": "No result",
      "suggestions": "Suggestions",
      "noSuggestions": "No suggestions",
      "selectLocation": "Select location",
      "address": "Address",
      "coordinates": "Coordinates",
      "confirm": "Yes"
    },
    "menu": {
      "bins": "Koše",
      "users": "Používatelia",
      "settings": "Nastavenia",
      "logs": "Logy",
      "sites": "Prevádzky",
      "fileManagement": "Súbory",
      "docs": "Documentation"
    },
    "bins": {
      "tooltip": {
        "fill": "Zapĺňanie",
        "door": "Dvere",
        "battery": "Batéria",
        "batteryVolts": "Batéria (V)",
        "heartbeat": "Životný signál",
        "lastHeartbeat": "Posledný životný signál"
      },
      "collectionList": "Zoznam vývozu",
      "collectionListTitle": "Tlačiteľný zoznam vývozu",
      "collectionListGenerate": "Otvoriť",
      "collectionListSort": {
        "order": "Poradie prev.",
        "fill": "Zapĺňanie",
        "mixed": "Zmiešané"
      },
      "collectionListUpdatedWithin": "Čerstvé (min)",
      "collectionListIncludeUnordered": "Vrátane bez poradia",
      "collectionListHint": "Otvorí tlačiteľné HTML v novej karte.",
      "map": "Mapa",
      "list": "Zoznam",
      "addNew": "Pridať kôš",
      "add": "Pridať",
      "listTitle": "Zoznam košov",
      "empty": "Žiadne koše. Pridajte vyššie.",
      "detailsTab": "Detaily",
      "form": {
        "identifier": "Identifikátor",
        "identifierPlaceholder": "napr. BIN-001",
        "latitudePlaceholder": "47.49",
        "longitudePlaceholder": "19.04",
        "add": "Pridať",
        "saving": "Ukladám...",
        "errorIdentifierRequired": "Identifikátor je povinný"
      },
      "details": {
        "mapPreview": "Náhľad mapy",
        "noCoordinates": "Žiadne súradnice",
        "latitude": "Z. šírka",
        "longitude": "Z. dĺžka",
        "useManual": "Ručné súradnice",
        "stats": {
          "filling": "Zapĺňanie",
          "state": "Stav",
          "battery": "Batéria",
          "solar": "Solár",
          "signal": "Signál",
          "availability": "Dostupnosť",
          "unlocked": "Odomknutý",
          "locked": "Zamknutý",
          "signalExcellent": "Výborný",
          "signalGood": "Dobrý",
          "signalWeak": "Slabý"
        },
        "innerTabs": {
          "details": "Detaily",
          "history": "História",
          "chart": "Graf",
          "settings": "Nastavenia",
          "lock": "Zámok",
          "service": "Servis",
          "availability": "Dostupnosť",
          "report": "Report"
        },
        "fields": {
          "serial": "Sériové číslo",
          "name": "Názov",
          "description": "Popis",
          "installationDate": "Dátum inštalácie",
          "version": "Verzia",
          "lastContact": "Posledný kontakt",
          "lastEmptied": "Posledné vyprázdnenie",
          "district": "Obvod",
          "location": "Pozícia"
        },
        "edit": "Upraviť",
        "editPosition": "Upraviť pozíciu",
        "dragHint": "Presuňte kôš na mape pre nastavenie novej pozície a potom uložte."
      },
      "mapLegend": {
        "title": "Zapĺňanie",
        "low": "< 70%",
        "medium": "70–89%",
        "high": "≥ 90%",
        "noData": "Žiadne dáta"
      },
      "latch": {
        "open": "Otvorené",
        "closed": "Zatvorené",
        "actionOpen": "prepnuť = Otvoriť",
        "actionClose": "prepnuť = Zatvoriť",
        "sendOpen": "Odoslať Otvoriť",
        "sendClose": "Odoslať Zatvoriť",
        "sending": "Odosielam..."
      },
      "maintenanceList": "Maintenance list",
      "maintenanceListTitle": "Printable maintenance list",
      "maintenanceListGenerate": "Open",
      "maintenanceListSort": {
        "battery": "Battery voltage"
      },
      "maintenanceListHint": "Open button shows printable HTML in new tab.",
      "selectSiteFirst": "Najprv vyberte lokalitu",
      "delete": "Delete",
      "restore": "Restore",
      "deletedBadge": "deleted",
      "emptyNoSites": "Before adding a bin you must create at least one site."
    },
    "logs": {
      "title": "Audit logy",
      "tabUsers": "Používatelia",
      "tabBins": "Koše",
      "loading": "Načítavam...",
      "time": "Čas",
      "action": "Akcia",
      "entity": "Entita",
      "entityId": "Entita ID",
      "userId": "Používateľ ID",
      "empty": "Žiadne dáta",
      "notAuthorized": "Bez oprávnenia",
      "detailsTitle": "Detaily",
      "diffBefore": "Pred",
      "diffAfter": "Po",
      "diffChanged": "Zmenené polia",
      "diffNoChanges": "Bez zmien",
      "close": "Zavrieť",
      "showRaw": "Zobraziť raw",
      "hideRaw": "Skryť raw",
      "tabMedia": "Fájlok",
      "entityIdBin": "Bin ID",
      "entityIdSite": "Site ID",
      "settingCol": "Setting",
      "filterTimeFrom": "From",
      "filterTimeTo": "To"
    },
    "users": {
      "management": "Správa používateľov",
      "users": "Používatelia",
      "addUser": "Pridať používateľa",
      "username": "Používateľské meno",
      "email": "Email",
      "role": "Rola",
      "actions": "Akcie",
      "create": "Vytvoriť",
      "cancel": "Zrušiť",
      "save": "Uložiť",
      "passwordPlaceholder": "heslo",
      "delete": "Zmazať",
      "restore": "Obnoviť",
      "deletedBadge": "zmazaný",
      "firstName": "Meno",
      "lastName": "Priezvisko",
      "phone": "Telefón",
      "validationMissingFields": "Vyplňte email, heslo, priezvisko a meno.",
      "edit": "Edit",
      "changePassword": "Change password",
      "newPassword": "New password",
      "confirmPassword": "Confirm password",
      "passwordUpdated": "Password updated",
      "deleteProtectedSuperadmin": "A superadmin felhasználó nem törölhető.",
      "protectedSuperadminBadge": "Szuperadmin (védett)",
      "passwordTooShort": "Minimum 8 characters",
      "passwordMismatch": "Passwords do not match",
      "passwordWeak": "Weak password: add uppercase and number",
      "passwordMedium": "Medium: add uppercase and number",
      "passwordStrong": "Strong password"
    },
    "confirm": {
      "titleDelete": "Zmazať používateľa",
      "titleRestore": "Obnoviť používateľa",
      "messageDelete": "Naozaj soft zmazať? Neprihlási sa kým neobnovíte.",
      "messageRestore": "Obnoviť používateľa? Znova sa prihlási.",
      "proceed": "Áno",
      "cancel": "Zrušiť"
    },
    "auth": {
      "login": "Prihlásenie",
      "register": "Registrácia",
      "email": "Email",
      "password": "Heslo",
      "haveAccount": "Máte účet?",
      "noAccount": "Nemáte účet?",
      "loginHere": "Prihlásiť tu",
      "registerHere": "Registrovať tu",
      "username": "Používateľské meno",
      "unexpectedError": "Nastala neočakávaná chyba. Skúste znova."
    },
    "settings": {
      "title": "Nastavenia",
      "language": "Jazyk",
      "selectLanguage": "Vyberte jazyk",
      "batteryLowThreshold": "Battery low threshold (V)",
      "batteryLowThresholdHint": "Battery overlay on map follows this threshold.",
      "fillGreenThreshold": "Telítettség zöld küszöb (%)",
      "fillYellowThreshold": "Telítettség sárga küszöb (%)",
      "fillRedThreshold": "Telítettség piros küszöb (%)",
      "fillThresholdsHint": "A telítettség színei (zöld/sárga/piros) ezekhez a küszöbökhöz igazodnak.",
      "saved": "Settings saved"
    },
    "media": {
      "title": "Správa súborov",
      "audioTab": "Audio súbory (WAV)",
      "imageTab": "Obrázky (BMP)",
      "upload": "Nahrať",
      "uploading": "Nahrávam...",
      "assign": "Priradiť",
      "assignBinPlaceholder": "ID koša",
      "publish": "Publikovať",
      "publishDisabledHint": "Neskôr",
      "fileName": "Názov súboru",
      "fileType": "Typ",
      "version": "Verzia",
      "bin": "Kôš",
      "sizeBytes": "Veľkosť (B)",
      "noFiles": "Žiadne súbory",
      "noMediaForBin": "Žiadne médiá pre tento kôš.",
      "action": {
        "open": "Otvoriť",
        "compression": "Komprimácia",
        "full": "Plný",
        "notice": "Oznámenie",
        "standby": "Pohotovosť"
      },
      "sitesGroup": "Prevádzky",
      "binsGroup": "Koše",
      "open": "Open",
      "delete": "Delete",
      "deleteDisabledHint": "Delete coming soon",
      "deleteConfirm": "Are you sure? This cannot be undone.",
      "deleteHint": "Permanently delete file",
      "deleting": "Deleting...",
      "actionColumn": "Action",
      "binColumn": "Bin",
      "allFiles": "All files",
      "bulkActionHint": "Individual actions",
      "actionSelectPlaceholder": "Action...",
      "binSelectPlaceholder": "Bin...",
      "confirmTitle": "Confirmation",
      "confirmPublish": "Are you sure you want to publish this file to the assigned bin?",
      "confirmPublishAll": "Are you sure you want to publish all files?",
      "publishMissingAction": "Select an action for every file",
      "deleteAllConfirm": "Are you sure you want to delete all files?"
    },
    "sites": {
      "title": "Prevádzky",
      "list": "Zoznam prevádzok",
      "addNew": "Pridať prevádzku",
      "selectPlaceholder": "Vyberte prevádzku",
      "validationSelectSite": "Vyberte prevádzku",
      "fields": {
        "code": "Kód",
        "name": "Názov",
        "address": "Adresa",
        "phone": "Telefón",
        "latitude": "Z. šírka",
        "longitude": "Z. dĺžka",
        "site": "Prevádzka",
        "coordinates": "Súradnice"
      },
      "placeholders": {
        "code": "napr. SITE1",
        "name": "Názov",
        "address": "Adresa",
        "phone": "Telefón",
        "latitude": "47.49",
        "longitude": "19.04"
      },
      "form": {
        "code": "Kód",
        "name": "Názov",
        "address": "Adresa",
        "phone": "Telefón",
        "latitude": "Z. šírka",
        "longitude": "Z. dĺžka",
        "create": "Vytvoriť",
        "requiredCode": "Kód je povinný",
        "requiredName": "Názov je povinný"
      },
      "validationCodeRequired": "Kód je povinný",
      "validationAddressChars": "Adresa obsahuje neplatné znaky",
      "validationAddressTooLong": "Adresa je príliš dlhá (max 180)",
      "validationAddressNeedStreetNumber": "Adresa musí obsahovať ulicu a číslo",
      "empty": "Žiadne prevádzky. Vytvorte jednu.",
      "code": "Kód",
      "name": "Názov",
      "address": "Adresa",
      "phone": "Telefón"
    },
    "docs": {
      "title": "Documentation",
      "intro": "Overview of the application by user roles.",
      "menu": {
        "title": "Sections"
      },
      "backTop": "Back to top",
      "general": {
        "title": "General Information",
        "purpose": "SmartBin helps operate bins transparently and in real time: it shows current fill level, battery status and lock state, assists with collection planning, and distributes media messages (audio/images).",
        "structure": "The app is straightforward: the left menu gives access to the main features (Bins, Sites, Files, Users, Settings, Logs). In Bins, view map and list with details, charts and history. In Files, manage audio/image files and assign them to bins. Logs shows an audit trail of key operations and events.",
        "features": {
          "mapList": "Map and list: quick overview with color-coded fill, battery and lock indicators.",
          "collection": "Collection list: filter by site and thresholds; printable/exportable.",
          "media": "Media: upload and distribute audio/image files; device acknowledgements (ACK) appear in Logs.",
          "sites": "Sites: manage locations to which bins belong.",
          "users": "Users: add, edit, change passwords; permissions differ by role.",
          "settings": "Settings: language and telemetry thresholds (battery, fill) affecting displayed indicators.",
          "logs": "Logs: auditing of essential system and user actions, with details and period filters."
        },
        "roles": "Roles: users can browse and view; managers and admins can modify, delete and administer the system. Superadmin has system-wide permissions and may remain hidden in some lists.",
        "tips": "Tips: use filters to find quickly; lists can be sorted and exported. If a device is offline/unreachable, indicators reflect that. Errors and acknowledgements are visible in Logs."
      },
      "legend": {
        "title": "Legend",
        "fill": {
          "title": "Fill",
          "green": "Green",
          "yellow": "Yellow",
          "red": "Red",
          "none": "No data"
        },
        "battery": {
          "title": "Battery",
          "ok": "OK",
          "low": "Low"
        },
        "lock": {
          "title": "Lock",
          "closed": "Closed",
          "open": "Open"
        },
        "signal": {
          "title": "Signal",
          "excellent": "Excellent",
          "good": "Good",
          "weak": "Weak"
        },
        "mediaAck": {
          "title": "Media ACK",
          "ok": "OK",
          "fail": "Fail"
        },
        "media": {
          "title": "Media",
          "audio": "Audio",
          "image": "Image"
        },
        "roles": {
          "title": "Roles",
          "superadmin": "Superadmin",
          "admin": "Admin",
          "manager": "Manager",
          "user": "User"
        },
        "sites": {
          "title": "Sites",
          "code": "Code",
          "location": "Location"
        }
      },
      "bins": {
        "title": "Bins",
        "overview": "In the Bins menu you can view the map, list and selected bin details.",
        "steps1": "Click “Bins” in the left menu. Use the top tabs to switch between Map and List. On the map click an icon for details; in the list click a row.",
        "map": "Map: color-coded icons (green/yellow/red), battery and lock overlays.",
        "list": "List: fill level progress bar, battery voltage, lock state, sorting.",
        "details": "Details: mini map, status cards, charts, history.",
        "manage": "Bin management: add, edit, delete, ordering, collection list generation.",
        "steps2": "New bin: top-right “+ New bin”. Edit: open details → “Edit”. Delete: click the “Delete” icon in the row.",
        "order": "Ordering: use Up/Down controls or drag in the list; save with “Save order”.",
        "collection": "Collection list: set filters (site, fill), then “Generate list”; export to PDF/CSV.",
        "userView": "As a user you can view the map and list, and details like fill level and status."
      },
      "sites": {
        "title": "Sites",
        "overview": "Manage and view sites."
      },
      "files": {
        "title": "Files",
        "overview": "Manage audio and image files, assign to bins.",
        "steps": "Open “Files”. Upload by dragging or clicking “Upload”. To assign, pick a bin then click “Assign” on the file."
      },
      "users": {
        "title": "Users",
        "overview": "Manage users: create, edit, delete, change password.",
        "steps": "Go to “Users”. New user: “+ New user”. Edit: “Edit” icon in the row. Role: choose from dropdown."
      },
      "settings": {
        "title": "Settings",
        "overview": "Global settings: language, telemetry thresholds (battery, fill), audit logging.",
        "steps": "Go to “Settings”. In Telemetry set battery low threshold and fill thresholds, then save.",
        "tips": "Tip: hover (i) icons for more info. If green upper ≤ red lower, Save may be disabled."
      },
      "admin": {
        "title": "Admin features",
        "overview": "Audit logs, role management, system configuration and advanced settings."
      },
      "logs": {
        "title": "Logs",
        "overview": "The Logs menu shows audit records and events. Filter by time, entity and action; details show before/after states of changes.",
        "mediaAck": "Media (image/audio) delivery acknowledgements (ACK) are highlighted and appear instantly via realtime events."
      }
    },
    "confirmBin": {
      "titleDelete": "Delete Bin",
      "titleRestore": "Restore Bin",
      "messageDelete": "Are you sure you want to soft delete this bin? It will disappear from the map until restored.",
      "messageRestore": "Restore this bin? It will appear again on the map.",
      "proceed": "Yes",
      "cancel": "Cancel"
    }
  },
  "ro": {
    "appTitle": "Panou SmartBin",
    "logout": "Deconectare",
    "common": {
      "refresh": "Reîmprospătare",
      "saving": "Se salvează...",
      "all": "Toate",
      "orderingMode": "Mod ordonare",
      "orderingStart": "Setează ordinea",
      "orderingStop": "Final ordonare",
      "orderingSave": "Salvează ordinea",
      "orderingCancel": "Anulează",
      "orderingCol": "Ord.",
      "addressCol": "Adresă / Coordonată",
      "addressFallback": "coordonată",
      "hideDeleted": "Hide deleted",
      "edit": "Edit",
      "save": "Save",
      "cancel": "Cancel",
      "preview": "Preview",
      "apply": "Apply",
      "geocoding": "Geocoding...",
      "noResult": "No result",
      "suggestions": "Suggestions",
      "noSuggestions": "No suggestions",
      "selectLocation": "Select location",
      "address": "Address",
      "coordinates": "Coordinates",
      "confirm": "Yes"
    },
    "menu": {
      "bins": "Containere",
      "users": "Utilizatori",
      "settings": "Setări",
      "logs": "Loguri",
      "sites": "Locații",
      "fileManagement": "Fișiere",
      "docs": "Documentation"
    },
    "bins": {
      "tooltip": {
        "fill": "Umplere",
        "door": "Ușă",
        "battery": "Baterie",
        "batteryVolts": "Baterie (V)",
        "heartbeat": "Puls",
        "lastHeartbeat": "Ultimul puls"
      },
      "map": "Hartă",
      "list": "Listă",
      "addNew": "Adaugă container",
      "add": "Adaugă",
      "listTitle": "Lista containerelor",
      "empty": "Niciun container. Adaugă mai sus.",
      "detailsTab": "Detalii",
      "form": {
        "identifier": "Identificator",
        "identifierPlaceholder": "ex. BIN-001",
        "latitudePlaceholder": "47.49",
        "longitudePlaceholder": "19.04",
        "add": "Adaugă",
        "saving": "Se salvează...",
        "errorIdentifierRequired": "Identificator necesar"
      },
      "details": {
        "mapPreview": "Previzualizare hartă",
        "noCoordinates": "Fără coordonate",
        "latitude": "Latitudine",
        "longitude": "Longitudine",
        "useManual": "Coordonate manuale",
        "stats": {
          "filling": "Umplere",
          "state": "Stare",
          "battery": "Baterie",
          "solar": "Solar",
          "signal": "Semnal",
          "availability": "Disponibilitate",
          "unlocked": "Deblocat",
          "locked": "Blocat",
          "signalExcellent": "Excelent",
          "signalGood": "Bun",
          "signalWeak": "Slab"
        },
        "innerTabs": {
          "details": "Detalii",
          "history": "Istoric",
          "chart": "Grafic",
          "settings": "Setări",
          "lock": "Blocare",
          "service": "Service",
          "availability": "Disponibilitate",
          "report": "Raport"
        },
        "fields": {
          "serial": "Serie",
          "name": "Nume",
          "description": "Descriere",
          "installationDate": "Data instalării",
          "version": "Versiune",
          "lastContact": "Ultimul contact",
          "lastEmptied": "Ultima golire",
          "district": "Sector",
          "location": "Locație"
        },
        "edit": "Editează",
        "editPosition": "Editează poziția",
        "dragHint": "Trageți containerul pe hartă pentru a seta o nouă poziție și apoi salvați."
      },
      "mapLegend": {
        "title": "Umplere",
        "low": "< 70%",
        "medium": "70–89%",
        "high": "≥ 90%",
        "noData": "Lipsă date"
      },
      "latch": {
        "open": "Deschis",
        "closed": "Închis",
        "actionOpen": "comută = Deschide",
        "actionClose": "comută = Închide",
        "sendOpen": "Trimite Deschidere",
        "sendClose": "Trimite Închidere",
        "sending": "Se trimite..."
      },
      "collectionList": "Collection list",
      "collectionListTitle": "Printable collection list",
      "collectionListGenerate": "Open",
      "collectionListSort": {
        "order": "Site order",
        "fill": "Fill level",
        "mixed": "Mixed"
      },
      "collectionListUpdatedWithin": "Fresh (min)",
      "collectionListIncludeUnordered": "Include unordered",
      "collectionListHint": "Open button shows printable HTML in new tab.",
      "maintenanceList": "Maintenance list",
      "maintenanceListTitle": "Printable maintenance list",
      "maintenanceListGenerate": "Open",
      "maintenanceListSort": {
        "battery": "Battery voltage"
      },
      "maintenanceListHint": "Open button shows printable HTML in new tab.",
      "selectSiteFirst": "Selectați mai întâi un amplasament",
      "delete": "Delete",
      "restore": "Restore",
      "deletedBadge": "deleted",
      "emptyNoSites": "Before adding a bin you must create at least one site."
    },
    "logs": {
      "title": "Loguri audit",
      "tabUsers": "Utilizatori",
      "tabBins": "Containere",
      "loading": "Încărcare...",
      "time": "Timp",
      "action": "Acțiune",
      "entity": "Entitate",
      "entityId": "ID entitate",
      "userId": "ID utilizator",
      "empty": "Fără date",
      "notAuthorized": "Neautorizat",
      "detailsTitle": "Detalii",
      "diffBefore": "Înainte",
      "diffAfter": "După",
      "diffChanged": "Câmpuri modificate",
      "diffNoChanges": "Fără modificări",
      "close": "Închide",
      "showRaw": "Arată brut",
      "hideRaw": "Ascunde brut",
      "tabMedia": "Fájlok",
      "entityIdBin": "Bin ID",
      "entityIdSite": "Site ID",
      "settingCol": "Setting",
      "filterTimeFrom": "From",
      "filterTimeTo": "To"
    },
    "users": {
      "management": "Administrare utilizatori",
      "users": "Utilizatori",
      "addUser": "Adaugă utilizator",
      "username": "Nume utilizator",
      "email": "Email",
      "role": "Rol",
      "actions": "Acțiuni",
      "create": "Creează",
      "cancel": "Anulează",
      "save": "Salvează",
      "passwordPlaceholder": "parolă",
      "delete": "Șterge",
      "restore": "Restaurează",
      "deletedBadge": "șters",
      "firstName": "Prenume",
      "lastName": "Nume",
      "phone": "Telefon",
      "validationMissingFields": "Completează email, parolă, nume și prenume.",
      "edit": "Edit",
      "changePassword": "Change password",
      "newPassword": "New password",
      "confirmPassword": "Confirm password",
      "passwordUpdated": "Password updated",
      "deleteProtectedSuperadmin": "A superadmin felhasználó nem törölhető.",
      "protectedSuperadminBadge": "Szuperadmin (védett)",
      "passwordTooShort": "Minimum 8 characters",
      "passwordMismatch": "Passwords do not match",
      "passwordWeak": "Weak password: add uppercase and number",
      "passwordMedium": "Medium: add uppercase and number",
      "passwordStrong": "Strong password"
    },
    "confirm": {
      "titleDelete": "Ștergere utilizator",
      "titleRestore": "Restaurare utilizator",
      "messageDelete": "Sigur ștergi (soft) acest utilizator? Nu se poate autentifica până la restaurare.",
      "messageRestore": "Restaurezi utilizatorul? Poate autentifica din nou.",
      "proceed": "Da",
      "cancel": "Anulează"
    },
    "auth": {
      "login": "Autentificare",
      "register": "Înregistrare",
      "email": "Email",
      "password": "Parolă",
      "haveAccount": "Ai deja cont?",
      "noAccount": "Nu ai cont?",
      "loginHere": "Autentifică-te aici",
      "registerHere": "Înregistrează-te aici",
      "username": "Nume utilizator",
      "unexpectedError": "A apărut o eroare neașteptată. Reîncearcă."
    },
    "settings": {
      "title": "Setări",
      "language": "Limbă",
      "selectLanguage": "Selectează limba",
      "batteryLowThreshold": "Battery low threshold (V)",
      "batteryLowThresholdHint": "Battery overlay on map follows this threshold.",
      "fillGreenThreshold": "Telítettség zöld küszöb (%)",
      "fillYellowThreshold": "Telítettség sárga küszöb (%)",
      "fillRedThreshold": "Telítettség piros küszöb (%)",
      "fillThresholdsHint": "A telítettség színei (zöld/sárga/piros) ezekhez a küszöbökhöz igazodnak.",
      "saved": "Settings saved"
    },
    "media": {
      "title": "Gestionare fișiere",
      "audioTab": "Fișiere audio (WAV)",
      "imageTab": "Fișiere imagine (BMP)",
      "upload": "Încarcă",
      "uploading": "Se încarcă...",
      "assign": "Asociază",
      "assignBinPlaceholder": "Bin ID",
      "publish": "Publică",
      "publishDisabledHint": "În curând",
      "fileName": "Nume fișier",
      "fileType": "Tip",
      "version": "Versiune",
      "bin": "Container",
      "sizeBytes": "Mărime (B)",
      "noFiles": "Fără fișiere",
      "noMediaForBin": "Fără media pentru acest container.",
      "action": {
        "open": "Deschide",
        "compression": "Compresie",
        "full": "Plin",
        "notice": "Notificare",
        "standby": "Așteptare"
      },
      "sitesGroup": "Locații",
      "binsGroup": "Containere",
      "open": "Open",
      "delete": "Delete",
      "deleteDisabledHint": "Delete coming soon",
      "deleteConfirm": "Are you sure? This cannot be undone.",
      "deleteHint": "Permanently delete file",
      "deleting": "Deleting...",
      "actionColumn": "Action",
      "binColumn": "Bin",
      "allFiles": "All files",
      "bulkActionHint": "Individual actions",
      "actionSelectPlaceholder": "Action...",
      "binSelectPlaceholder": "Bin...",
      "confirmTitle": "Confirmation",
      "confirmPublish": "Are you sure you want to publish this file to the assigned bin?",
      "confirmPublishAll": "Are you sure you want to publish all files?",
      "publishMissingAction": "Select an action for every file",
      "deleteAllConfirm": "Are you sure you want to delete all files?"
    },
    "sites": {
      "title": "Locații",
      "list": "Lista locațiilor",
      "addNew": "Adaugă locație",
      "selectPlaceholder": "Selectează locația",
      "validationSelectSite": "Selectează locația",
      "fields": {
        "code": "Cod",
        "name": "Nume",
        "address": "Adresă",
        "phone": "Telefon",
        "latitude": "Latitudine",
        "longitude": "Longitudine",
        "site": "Locație",
        "coordinates": "Coordonate"
      },
      "placeholders": {
        "code": "ex. SITE1",
        "name": "Nume",
        "address": "Adresă",
        "phone": "Telefon",
        "latitude": "47.49",
        "longitude": "19.04"
      },
      "form": {
        "code": "Cod",
        "name": "Nume",
        "address": "Adresă",
        "phone": "Telefon",
        "latitude": "Latitudine",
        "longitude": "Longitudine",
        "create": "Creează",
        "requiredCode": "Cod necesar",
        "requiredName": "Nume necesar"
      },
      "validationCodeRequired": "Cod necesar",
      "validationAddressChars": "Adresă conține caractere invalide",
      "validationAddressTooLong": "Adresă prea lungă (max 180)",
      "validationAddressNeedStreetNumber": "Adresă trebuie să conțină stradă și număr",
      "empty": "Nu există locații. Creează una.",
      "code": "Cod",
      "name": "Nume",
      "address": "Adresă",
      "phone": "Telefon"
    },
    "docs": {
      "title": "Documentation",
      "intro": "Overview of the application by user roles.",
      "menu": {
        "title": "Sections"
      },
      "backTop": "Back to top",
      "general": {
        "title": "General Information",
        "purpose": "SmartBin helps operate bins transparently and in real time: it shows current fill level, battery status and lock state, assists with collection planning, and distributes media messages (audio/images).",
        "structure": "The app is straightforward: the left menu gives access to the main features (Bins, Sites, Files, Users, Settings, Logs). In Bins, view map and list with details, charts and history. In Files, manage audio/image files and assign them to bins. Logs shows an audit trail of key operations and events.",
        "features": {
          "mapList": "Map and list: quick overview with color-coded fill, battery and lock indicators.",
          "collection": "Collection list: filter by site and thresholds; printable/exportable.",
          "media": "Media: upload and distribute audio/image files; device acknowledgements (ACK) appear in Logs.",
          "sites": "Sites: manage locations to which bins belong.",
          "users": "Users: add, edit, change passwords; permissions differ by role.",
          "settings": "Settings: language and telemetry thresholds (battery, fill) affecting displayed indicators.",
          "logs": "Logs: auditing of essential system and user actions, with details and period filters."
        },
        "roles": "Roles: users can browse and view; managers and admins can modify, delete and administer the system. Superadmin has system-wide permissions and may remain hidden in some lists.",
        "tips": "Tips: use filters to find quickly; lists can be sorted and exported. If a device is offline/unreachable, indicators reflect that. Errors and acknowledgements are visible in Logs."
      },
      "legend": {
        "title": "Legend",
        "fill": {
          "title": "Fill",
          "green": "Green",
          "yellow": "Yellow",
          "red": "Red",
          "none": "No data"
        },
        "battery": {
          "title": "Battery",
          "ok": "OK",
          "low": "Low"
        },
        "lock": {
          "title": "Lock",
          "closed": "Closed",
          "open": "Open"
        },
        "signal": {
          "title": "Signal",
          "excellent": "Excellent",
          "good": "Good",
          "weak": "Weak"
        },
        "mediaAck": {
          "title": "Media ACK",
          "ok": "OK",
          "fail": "Fail"
        },
        "media": {
          "title": "Media",
          "audio": "Audio",
          "image": "Image"
        },
        "roles": {
          "title": "Roles",
          "superadmin": "Superadmin",
          "admin": "Admin",
          "manager": "Manager",
          "user": "User"
        },
        "sites": {
          "title": "Sites",
          "code": "Code",
          "location": "Location"
        }
      },
      "bins": {
        "title": "Bins",
        "overview": "In the Bins menu you can view the map, list and selected bin details.",
        "steps1": "Click “Bins” in the left menu. Use the top tabs to switch between Map and List. On the map click an icon for details; in the list click a row.",
        "map": "Map: color-coded icons (green/yellow/red), battery and lock overlays.",
        "list": "List: fill level progress bar, battery voltage, lock state, sorting.",
        "details": "Details: mini map, status cards, charts, history.",
        "manage": "Bin management: add, edit, delete, ordering, collection list generation.",
        "steps2": "New bin: top-right “+ New bin”. Edit: open details → “Edit”. Delete: click the “Delete” icon in the row.",
        "order": "Ordering: use Up/Down controls or drag in the list; save with “Save order”.",
        "collection": "Collection list: set filters (site, fill), then “Generate list”; export to PDF/CSV.",
        "userView": "As a user you can view the map and list, and details like fill level and status."
      },
      "sites": {
        "title": "Sites",
        "overview": "Manage and view sites."
      },
      "files": {
        "title": "Files",
        "overview": "Manage audio and image files, assign to bins.",
        "steps": "Open “Files”. Upload by dragging or clicking “Upload”. To assign, pick a bin then click “Assign” on the file."
      },
      "users": {
        "title": "Users",
        "overview": "Manage users: create, edit, delete, change password.",
        "steps": "Go to “Users”. New user: “+ New user”. Edit: “Edit” icon in the row. Role: choose from dropdown."
      },
      "settings": {
        "title": "Settings",
        "overview": "Global settings: language, telemetry thresholds (battery, fill), audit logging.",
        "steps": "Go to “Settings”. In Telemetry set battery low threshold and fill thresholds, then save.",
        "tips": "Tip: hover (i) icons for more info. If green upper ≤ red lower, Save may be disabled."
      },
      "admin": {
        "title": "Admin features",
        "overview": "Audit logs, role management, system configuration and advanced settings."
      },
      "logs": {
        "title": "Logs",
        "overview": "The Logs menu shows audit records and events. Filter by time, entity and action; details show before/after states of changes.",
        "mediaAck": "Media (image/audio) delivery acknowledgements (ACK) are highlighted and appear instantly via realtime events."
      }
    },
    "confirmBin": {
      "titleDelete": "Delete Bin",
      "titleRestore": "Restore Bin",
      "messageDelete": "Are you sure you want to soft delete this bin? It will disappear from the map until restored.",
      "messageRestore": "Restore this bin? It will appear again on the map.",
      "proceed": "Yes",
      "cancel": "Cancel"
    }
  },
  "bg": {
    "appTitle": "SmartBin Табло",
    "logout": "Изход",
    "common": {
      "refresh": "Опресни",
      "saving": "Записване...",
      "all": "Всички",
      "orderingMode": "Режим ред",
      "orderingStart": "Задай ред",
      "orderingStop": "Край ред",
      "orderingSave": "Запази реда",
      "orderingCancel": "Отказ",
      "orderingCol": "Ред",
      "addressCol": "Адрес / Координата",
      "addressFallback": "координата",
      "hideDeleted": "Hide deleted",
      "edit": "Edit",
      "save": "Save",
      "cancel": "Cancel",
      "preview": "Preview",
      "apply": "Apply",
      "geocoding": "Geocoding...",
      "noResult": "No result",
      "suggestions": "Suggestions",
      "noSuggestions": "No suggestions",
      "selectLocation": "Select location",
      "address": "Address",
      "coordinates": "Coordinates",
      "confirm": "Yes"
    },
    "menu": {
      "bins": "Контейнери",
      "users": "Потребители",
      "settings": "Настройки",
      "logs": "Логове",
      "sites": "Локации",
      "fileManagement": "Файлове",
      "docs": "Documentation"
    },
    "bins": {
      "tooltip": {
        "fill": "Запълване",
        "door": "Врата",
        "battery": "Батерия",
        "batteryVolts": "Батерия (V)",
        "heartbeat": "Пулс",
        "lastHeartbeat": "Последен пулс"
      },
      "map": "Карта",
      "list": "Списък",
      "addNew": "Добави контейнер",
      "add": "Добави",
      "listTitle": "Списък контейнери",
      "empty": "Няма контейнери. Добавете отгоре.",
      "detailsTab": "Детайли",
      "form": {
        "identifier": "Идентификатор",
        "identifierPlaceholder": "напр. BIN-001",
        "latitudePlaceholder": "47.49",
        "longitudePlaceholder": "19.04",
        "add": "Добави",
        "saving": "Записване...",
        "errorIdentifierRequired": "Идентификатор задължителен"
      },
      "details": {
        "mapPreview": "Преглед на карта",
        "noCoordinates": "Няма координати",
        "latitude": "Ширина",
        "longitude": "Дължина",
        "useManual": "Ръчни координати",
        "stats": {
          "filling": "Запълване",
          "state": "Състояние",
          "battery": "Батерия",
          "solar": "Солар",
          "signal": "Сигнал",
          "availability": "Наличност",
          "unlocked": "Отключен",
          "locked": "Заключен",
          "signalExcellent": "Отличен",
          "signalGood": "Добър",
          "signalWeak": "Слаб"
        },
        "innerTabs": {
          "details": "Детайли",
          "history": "История",
          "chart": "Графика",
          "settings": "Настройки",
          "lock": "Заключване",
          "service": "Сервиз",
          "availability": "Наличност",
          "report": "Отчет"
        },
        "fields": {
          "serial": "Сериен №",
          "name": "Име",
          "description": "Описание",
          "installationDate": "Дата на инст.",
          "version": "Версия",
          "lastContact": "Последен контакт",
          "lastEmptied": "Последно изпразнен",
          "district": "Район",
          "location": "Локация"
        },
        "edit": "Редакция",
        "editPosition": "Редакция на позиция",
        "dragHint": "Преместете контейнера на картата, за да зададете нова позиция и след това запазете."
      },
      "mapLegend": {
        "title": "Запълване",
        "low": "< 70%",
        "medium": "70–89%",
        "high": "≥ 90%",
        "noData": "Няма данни"
      },
      "latch": {
        "open": "Отворен",
        "closed": "Затворен",
        "actionOpen": "превключи = Отвори",
        "actionClose": "превключи = Затвори",
        "sendOpen": "Изпрати Отваряне",
        "sendClose": "Изпрати Затваряне",
        "sending": "Изпращане..."
      },
      "collectionList": "Collection list",
      "collectionListTitle": "Printable collection list",
      "collectionListGenerate": "Open",
      "collectionListSort": {
        "order": "Site order",
        "fill": "Fill level",
        "mixed": "Mixed"
      },
      "collectionListUpdatedWithin": "Fresh (min)",
      "collectionListIncludeUnordered": "Include unordered",
      "collectionListHint": "Open button shows printable HTML in new tab.",
      "maintenanceList": "Maintenance list",
      "maintenanceListTitle": "Printable maintenance list",
      "maintenanceListGenerate": "Open",
      "maintenanceListSort": {
        "battery": "Battery voltage"
      },
      "maintenanceListHint": "Open button shows printable HTML in new tab.",
      "selectSiteFirst": "Изберете първо обект",
      "delete": "Delete",
      "restore": "Restore",
      "deletedBadge": "deleted",
      "emptyNoSites": "Before adding a bin you must create at least one site."
    },
    "logs": {
      "title": "Аудит логове",
      "tabUsers": "Потребители",
      "tabBins": "Контейнери",
      "loading": "Зареждане...",
      "time": "Време",
      "action": "Действие",
      "entity": "Ентити",
      "entityId": "ID ентити",
      "userId": "ID потребител",
      "empty": "Няма данни",
      "notAuthorized": "Нямате права",
      "detailsTitle": "Детайли",
      "diffBefore": "Преди",
      "diffAfter": "След",
      "diffChanged": "Променени полета",
      "diffNoChanges": "Няма промени",
      "close": "Затвори",
      "showRaw": "Покажи raw",
      "hideRaw": "Скрий raw",
      "tabMedia": "Fájlok",
      "entityIdBin": "Bin ID",
      "entityIdSite": "Site ID",
      "settingCol": "Setting",
      "filterTimeFrom": "From",
      "filterTimeTo": "To"
    },
    "users": {
      "management": "Управление на потребители",
      "users": "Потребители",
      "addUser": "Добави потребител",
      "username": "Потребителско име",
      "email": "Имейл",
      "role": "Роля",
      "actions": "Действия",
      "create": "Създай",
      "cancel": "Отказ",
      "save": "Запази",
      "passwordPlaceholder": "парола",
      "delete": "Изтрий",
      "restore": "Възстанови",
      "deletedBadge": "изтрит",
      "firstName": "Име",
      "lastName": "Фамилия",
      "phone": "Телефон",
      "validationMissingFields": "Попълнете имейл, парола, фамилия и име.",
      "edit": "Edit",
      "changePassword": "Change password",
      "newPassword": "New password",
      "confirmPassword": "Confirm password",
      "passwordUpdated": "Password updated",
      "deleteProtectedSuperadmin": "A superadmin felhasználó nem törölhető.",
      "protectedSuperadminBadge": "Szuperadmin (védett)",
      "passwordTooShort": "Minimum 8 characters",
      "passwordMismatch": "Passwords do not match",
      "passwordWeak": "Weak password: add uppercase and number",
      "passwordMedium": "Medium: add uppercase and number",
      "passwordStrong": "Strong password"
    },
    "confirm": {
      "titleDelete": "Изтриване на потребител",
      "titleRestore": "Възстановяване на потребител",
      "messageDelete": "Сигурни ли сте, че искате да изтриете (soft) потребителя? Няма да влезе до възстановяване.",
      "messageRestore": "Възстановяване на потребителя? Ще може да влезе отново.",
      "proceed": "Да",
      "cancel": "Отказ"
    },
    "auth": {
      "login": "Вход",
      "register": "Регистрация",
      "email": "Имейл",
      "password": "Парола",
      "haveAccount": "Имате акаунт?",
      "noAccount": "Нямате акаунт?",
      "loginHere": "Вход тук",
      "registerHere": "Регистрация тук",
      "username": "Потребителско име",
      "unexpectedError": "Възникна неочаквана грешка. Опитайте отново."
    },
    "settings": {
      "title": "Настройки",
      "language": "Език",
      "selectLanguage": "Изберете език",
      "batteryLowThreshold": "Battery low threshold (V)",
      "batteryLowThresholdHint": "Battery overlay on map follows this threshold.",
      "fillGreenThreshold": "Telítettség zöld küszöb (%)",
      "fillYellowThreshold": "Telítettség sárga küszöb (%)",
      "fillRedThreshold": "Telítettség piros küszöb (%)",
      "fillThresholdsHint": "A telítettség színei (zöld/sárga/piros) ezekhez a küszöbökhöz igazodnak.",
      "saved": "Settings saved"
    },
    "media": {
      "title": "Управление на файлове",
      "audioTab": "Аудио (WAV)",
      "imageTab": "Изображения (BMP)",
      "upload": "Качи",
      "uploading": "Качване...",
      "assign": "Свържи",
      "assignBinPlaceholder": "ID контейнер",
      "publish": "Публикувай",
      "publishDisabledHint": "По-късно",
      "fileName": "Име на файл",
      "fileType": "Тип",
      "version": "Версия",
      "bin": "Контейнер",
      "sizeBytes": "Размер (B)",
      "noFiles": "Няма файлове",
      "noMediaForBin": "Няма медия за този контейнер.",
      "action": {
        "open": "Отвори",
        "compression": "Компресия",
        "full": "Пълен",
        "notice": "Известие",
        "standby": "Режим готовност"
      },
      "sitesGroup": "Локации",
      "binsGroup": "Контейнери",
      "open": "Open",
      "delete": "Delete",
      "deleteDisabledHint": "Delete coming soon",
      "deleteConfirm": "Are you sure? This cannot be undone.",
      "deleteHint": "Permanently delete file",
      "deleting": "Deleting...",
      "actionColumn": "Action",
      "binColumn": "Bin",
      "allFiles": "All files",
      "bulkActionHint": "Individual actions",
      "actionSelectPlaceholder": "Action...",
      "binSelectPlaceholder": "Bin...",
      "confirmTitle": "Confirmation",
      "confirmPublish": "Are you sure you want to publish this file to the assigned bin?",
      "confirmPublishAll": "Are you sure you want to publish all files?",
      "publishMissingAction": "Select an action for every file",
      "deleteAllConfirm": "Are you sure you want to delete all files?"
    },
    "sites": {
      "title": "Локации",
      "list": "Списък локации",
      "addNew": "Добави локация",
      "selectPlaceholder": "Избери локация",
      "validationSelectSite": "Избери локация",
      "fields": {
        "code": "Код",
        "name": "Име",
        "address": "Адрес",
        "phone": "Телефон",
        "latitude": "Ширина",
        "longitude": "Дължина",
        "site": "Локация",
        "coordinates": "Координати"
      },
      "placeholders": {
        "code": "напр. SITE1",
        "name": "Име",
        "address": "Адрес",
        "phone": "Телефон",
        "latitude": "47.49",
        "longitude": "19.04"
      },
      "form": {
        "code": "Код",
        "name": "Име",
        "address": "Адрес",
        "phone": "Телефон",
        "latitude": "Ширина",
        "longitude": "Дължина",
        "create": "Създай",
        "requiredCode": "Код задължителен",
        "requiredName": "Име задължително"
      },
      "validationCodeRequired": "Код задължителен",
      "validationAddressChars": "Адресът съдържа невалидни символи",
      "validationAddressTooLong": "Адресът е твърде дълъг (макс 180)",
      "validationAddressNeedStreetNumber": "Адресът трябва да съдържа улица и номер",
      "empty": "Няма локации. Създай една.",
      "code": "Код",
      "name": "Име",
      "address": "Адрес",
      "phone": "Телефон"
    },
    "docs": {
      "title": "Documentation",
      "intro": "Overview of the application by user roles.",
      "menu": {
        "title": "Sections"
      },
      "backTop": "Back to top",
      "general": {
        "title": "General Information",
        "purpose": "SmartBin helps operate bins transparently and in real time: it shows current fill level, battery status and lock state, assists with collection planning, and distributes media messages (audio/images).",
        "structure": "The app is straightforward: the left menu gives access to the main features (Bins, Sites, Files, Users, Settings, Logs). In Bins, view map and list with details, charts and history. In Files, manage audio/image files and assign them to bins. Logs shows an audit trail of key operations and events.",
        "features": {
          "mapList": "Map and list: quick overview with color-coded fill, battery and lock indicators.",
          "collection": "Collection list: filter by site and thresholds; printable/exportable.",
          "media": "Media: upload and distribute audio/image files; device acknowledgements (ACK) appear in Logs.",
          "sites": "Sites: manage locations to which bins belong.",
          "users": "Users: add, edit, change passwords; permissions differ by role.",
          "settings": "Settings: language and telemetry thresholds (battery, fill) affecting displayed indicators.",
          "logs": "Logs: auditing of essential system and user actions, with details and period filters."
        },
        "roles": "Roles: users can browse and view; managers and admins can modify, delete and administer the system. Superadmin has system-wide permissions and may remain hidden in some lists.",
        "tips": "Tips: use filters to find quickly; lists can be sorted and exported. If a device is offline/unreachable, indicators reflect that. Errors and acknowledgements are visible in Logs."
      },
      "legend": {
        "title": "Legend",
        "fill": {
          "title": "Fill",
          "green": "Green",
          "yellow": "Yellow",
          "red": "Red",
          "none": "No data"
        },
        "battery": {
          "title": "Battery",
          "ok": "OK",
          "low": "Low"
        },
        "lock": {
          "title": "Lock",
          "closed": "Closed",
          "open": "Open"
        },
        "signal": {
          "title": "Signal",
          "excellent": "Excellent",
          "good": "Good",
          "weak": "Weak"
        },
        "mediaAck": {
          "title": "Media ACK",
          "ok": "OK",
          "fail": "Fail"
        },
        "media": {
          "title": "Media",
          "audio": "Audio",
          "image": "Image"
        },
        "roles": {
          "title": "Roles",
          "superadmin": "Superadmin",
          "admin": "Admin",
          "manager": "Manager",
          "user": "User"
        },
        "sites": {
          "title": "Sites",
          "code": "Code",
          "location": "Location"
        }
      },
      "bins": {
        "title": "Bins",
        "overview": "In the Bins menu you can view the map, list and selected bin details.",
        "steps1": "Click “Bins” in the left menu. Use the top tabs to switch between Map and List. On the map click an icon for details; in the list click a row.",
        "map": "Map: color-coded icons (green/yellow/red), battery and lock overlays.",
        "list": "List: fill level progress bar, battery voltage, lock state, sorting.",
        "details": "Details: mini map, status cards, charts, history.",
        "manage": "Bin management: add, edit, delete, ordering, collection list generation.",
        "steps2": "New bin: top-right “+ New bin”. Edit: open details → “Edit”. Delete: click the “Delete” icon in the row.",
        "order": "Ordering: use Up/Down controls or drag in the list; save with “Save order”.",
        "collection": "Collection list: set filters (site, fill), then “Generate list”; export to PDF/CSV.",
        "userView": "As a user you can view the map and list, and details like fill level and status."
      },
      "sites": {
        "title": "Sites",
        "overview": "Manage and view sites."
      },
      "files": {
        "title": "Files",
        "overview": "Manage audio and image files, assign to bins.",
        "steps": "Open “Files”. Upload by dragging or clicking “Upload”. To assign, pick a bin then click “Assign” on the file."
      },
      "users": {
        "title": "Users",
        "overview": "Manage users: create, edit, delete, change password.",
        "steps": "Go to “Users”. New user: “+ New user”. Edit: “Edit” icon in the row. Role: choose from dropdown."
      },
      "settings": {
        "title": "Settings",
        "overview": "Global settings: language, telemetry thresholds (battery, fill), audit logging.",
        "steps": "Go to “Settings”. In Telemetry set battery low threshold and fill thresholds, then save.",
        "tips": "Tip: hover (i) icons for more info. If green upper ≤ red lower, Save may be disabled."
      },
      "admin": {
        "title": "Admin features",
        "overview": "Audit logs, role management, system configuration and advanced settings."
      },
      "logs": {
        "title": "Logs",
        "overview": "The Logs menu shows audit records and events. Filter by time, entity and action; details show before/after states of changes.",
        "mediaAck": "Media (image/audio) delivery acknowledgements (ACK) are highlighted and appear instantly via realtime events."
      }
    },
    "confirmBin": {
      "titleDelete": "Delete Bin",
      "titleRestore": "Restore Bin",
      "messageDelete": "Are you sure you want to soft delete this bin? It will disappear from the map until restored.",
      "messageRestore": "Restore this bin? It will appear again on the map.",
      "proceed": "Yes",
      "cancel": "Cancel"
    }
  },
  "ru": {
    "appTitle": "SmartBin Панель",
    "logout": "Выход",
    "common": {
      "refresh": "Обновить",
      "saving": "Сохранение...",
      "all": "Все",
      "orderingMode": "Режим порядка",
      "orderingStart": "Задать порядок",
      "orderingStop": "Завершить",
      "orderingSave": "Сохранить порядок",
      "orderingCancel": "Отмена",
      "orderingCol": "Поряд.",
      "addressCol": "Адрес / Коорд.",
      "addressFallback": "координата",
      "hideDeleted": "Hide deleted",
      "edit": "Edit",
      "save": "Save",
      "cancel": "Cancel",
      "preview": "Preview",
      "apply": "Apply",
      "geocoding": "Geocoding...",
      "noResult": "No result",
      "suggestions": "Suggestions",
      "noSuggestions": "No suggestions",
      "selectLocation": "Select location",
      "address": "Address",
      "coordinates": "Coordinates",
      "confirm": "Yes"
    },
    "menu": {
      "bins": "Контейнеры",
      "users": "Пользователи",
      "settings": "Настройки",
      "logs": "Логи",
      "sites": "Площадки",
      "fileManagement": "Файлы",
      "docs": "Documentation"
    },
    "bins": {
      "tooltip": {
        "fill": "Заполнение",
        "door": "Дверь",
        "battery": "Батарея",
        "batteryVolts": "Батарея (В)",
        "heartbeat": "Пульс",
        "lastHeartbeat": "Последний пульс"
      },
      "map": "Карта",
      "list": "Список",
      "addNew": "Добавить контейнер",
      "add": "Добавить",
      "listTitle": "Список контейнеров",
      "empty": "Нет контейнеров. Добавьте выше.",
      "detailsTab": "Детали",
      "form": {
        "identifier": "Идентификатор",
        "identifierPlaceholder": "напр. BIN-001",
        "latitudePlaceholder": "47.49",
        "longitudePlaceholder": "19.04",
        "add": "Добавить",
        "saving": "Сохранение...",
        "errorIdentifierRequired": "Идентификатор обязателен"
      },
      "details": {
        "mapPreview": "Предпросмотр карты",
        "noCoordinates": "Нет координат",
        "latitude": "Широта",
        "longitude": "Долгота",
        "useManual": "Ручные координаты",
        "stats": {
          "filling": "Заполнение",
          "state": "Состояние",
          "battery": "Батарея",
          "solar": "Солнечн.",
          "signal": "Сигнал",
          "availability": "Доступность",
          "unlocked": "Открыт",
          "locked": "Закрыт",
          "signalExcellent": "Отличный",
          "signalGood": "Хороший",
          "signalWeak": "Слабый"
        },
        "innerTabs": {
          "details": "Детали",
          "history": "История",
          "chart": "График",
          "settings": "Настройки",
          "lock": "Замок",
          "service": "Сервис",
          "availability": "Доступность",
          "report": "Отчёт"
        },
        "fields": {
          "serial": "Серийный №",
          "name": "Имя",
          "description": "Описание",
          "installationDate": "Установка",
          "version": "Версия",
          "lastContact": "Последний контакт",
          "lastEmptied": "Последняя очистка",
          "district": "Район",
          "location": "Локация"
        },
        "edit": "Редакт.",
        "editPosition": "Редакт. позиции",
        "dragHint": "Перетащите контейнер на карте, чтобы задать новую позицию, затем сохраните."
      },
      "mapLegend": {
        "title": "Заполнение",
        "low": "< 70%",
        "medium": "70–89%",
        "high": "≥ 90%",
        "noData": "Нет данных"
      },
      "latch": {
        "open": "Открыт",
        "closed": "Закрыт",
        "actionOpen": "переключить = Открыть",
        "actionClose": "переключить = Закрыть",
        "sendOpen": "Отправить Открыть",
        "sendClose": "Отправить Закрыть",
        "sending": "Отправка..."
      },
      "collectionList": "Collection list",
      "collectionListTitle": "Printable collection list",
      "collectionListGenerate": "Open",
      "collectionListSort": {
        "order": "Site order",
        "fill": "Fill level",
        "mixed": "Mixed"
      },
      "collectionListUpdatedWithin": "Fresh (min)",
      "collectionListIncludeUnordered": "Include unordered",
      "collectionListHint": "Open button shows printable HTML in new tab.",
      "maintenanceList": "Maintenance list",
      "maintenanceListTitle": "Printable maintenance list",
      "maintenanceListGenerate": "Open",
      "maintenanceListSort": {
        "battery": "Battery voltage"
      },
      "maintenanceListHint": "Open button shows printable HTML in new tab.",
      "selectSiteFirst": "Сначала выберите объект",
      "delete": "Delete",
      "restore": "Restore",
      "deletedBadge": "deleted",
      "emptyNoSites": "Before adding a bin you must create at least one site."
    },
    "logs": {
      "title": "Аудит логи",
      "tabUsers": "Пользователи",
      "tabBins": "Контейнеры",
      "loading": "Загрузка...",
      "time": "Время",
      "action": "Действие",
      "entity": "Сущность",
      "entityId": "ID сущности",
      "userId": "ID пользователя",
      "empty": "Нет данных",
      "notAuthorized": "Нет доступа",
      "detailsTitle": "Детали",
      "diffBefore": "До",
      "diffAfter": "После",
      "diffChanged": "Изменённые поля",
      "diffNoChanges": "Без изменений",
      "close": "Закрыть",
      "showRaw": "Показать raw",
      "hideRaw": "Скрыть raw",
      "tabMedia": "Fájlok",
      "entityIdBin": "Bin ID",
      "entityIdSite": "Site ID",
      "settingCol": "Setting",
      "filterTimeFrom": "From",
      "filterTimeTo": "To"
    },
    "users": {
      "management": "Управление пользователями",
      "users": "Пользователи",
      "addUser": "Добавить пользователя",
      "username": "Имя пользователя",
      "email": "Email",
      "role": "Роль",
      "actions": "Действия",
      "create": "Создать",
      "cancel": "Отмена",
      "save": "Сохранить",
      "passwordPlaceholder": "пароль",
      "delete": "Удалить",
      "restore": "Восстановить",
      "deletedBadge": "удалён",
      "firstName": "Имя",
      "lastName": "Фамилия",
      "phone": "Телефон",
      "validationMissingFields": "Заполните email, пароль, фамилию и имя.",
      "edit": "Edit",
      "changePassword": "Change password",
      "newPassword": "New password",
      "confirmPassword": "Confirm password",
      "passwordUpdated": "Password updated",
      "deleteProtectedSuperadmin": "A superadmin felhasználó nem törölhető.",
      "protectedSuperadminBadge": "Szuperadmin (védett)",
      "passwordTooShort": "Minimum 8 characters",
      "passwordMismatch": "Passwords do not match",
      "passwordWeak": "Weak password: add uppercase and number",
      "passwordMedium": "Medium: add uppercase and number",
      "passwordStrong": "Strong password"
    },
    "confirm": {
      "titleDelete": "Удалить пользователя",
      "titleRestore": "Восстановить пользователя",
      "messageDelete": "Действительно удалить (soft)? Не войдёт пока не восстановите.",
      "messageRestore": "Восстановить пользователя? Сможет войти снова.",
      "proceed": "Да",
      "cancel": "Отмена"
    },
    "auth": {
      "login": "Вход",
      "register": "Регистрация",
      "email": "Email",
      "password": "Пароль",
      "haveAccount": "Уже есть аккаунт?",
      "noAccount": "Нет аккаунта?",
      "loginHere": "Войти здесь",
      "registerHere": "Регистрация здесь",
      "username": "Имя пользователя",
      "unexpectedError": "Произошла непредвиденная ошибка. Повторите попытку."
    },
    "settings": {
      "title": "Настройки",
      "language": "Язык",
      "selectLanguage": "Выберите язык",
      "batteryLowThreshold": "Battery low threshold (V)",
      "batteryLowThresholdHint": "Battery overlay on map follows this threshold.",
      "fillGreenThreshold": "Telítettség zöld küszöb (%)",
      "fillYellowThreshold": "Telítettség sárga küszöb (%)",
      "fillRedThreshold": "Telítettség piros küszöb (%)",
      "fillThresholdsHint": "A telítettség színei (zöld/sárga/piros) ezekhez a küszöbökhöz igazodnak.",
      "saved": "Settings saved"
    },
    "media": {
      "title": "Управление файлами",
      "audioTab": "Аудио файлы (WAV)",
      "imageTab": "Изображения (BMP)",
      "upload": "Загрузить",
      "uploading": "Загрузка...",
      "assign": "Назначить",
      "assignBinPlaceholder": "ID контейнера",
      "publish": "Опубликовать",
      "publishDisabledHint": "Позже",
      "fileName": "Имя файла",
      "fileType": "Тип",
      "version": "Версия",
      "bin": "Контейнер",
      "sizeBytes": "Размер (B)",
      "noFiles": "Нет файлов",
      "noMediaForBin": "Нет медиа для этого контейнера.",
      "action": {
        "open": "Открыть",
        "compression": "Сжатие",
        "full": "Полный",
        "notice": "Уведомление",
        "standby": "Ожидание"
      },
      "sitesGroup": "Площадки",
      "binsGroup": "Контейнеры",
      "open": "Open",
      "delete": "Delete",
      "deleteDisabledHint": "Delete coming soon",
      "deleteConfirm": "Are you sure? This cannot be undone.",
      "deleteHint": "Permanently delete file",
      "deleting": "Deleting...",
      "actionColumn": "Action",
      "binColumn": "Bin",
      "allFiles": "All files",
      "bulkActionHint": "Individual actions",
      "actionSelectPlaceholder": "Action...",
      "binSelectPlaceholder": "Bin...",
      "confirmTitle": "Confirmation",
      "confirmPublish": "Are you sure you want to publish this file to the assigned bin?",
      "confirmPublishAll": "Are you sure you want to publish all files?",
      "publishMissingAction": "Select an action for every file",
      "deleteAllConfirm": "Are you sure you want to delete all files?"
    },
    "sites": {
      "title": "Площадки",
      "list": "Список площадок",
      "addNew": "Добавить площадку",
      "selectPlaceholder": "Выберите площадку",
      "validationSelectSite": "Выберите площадку",
      "fields": {
        "code": "Код",
        "name": "Название",
        "address": "Адрес",
        "phone": "Телефон",
        "latitude": "Широта",
        "longitude": "Долгота",
        "site": "Площадка",
        "coordinates": "Координаты"
      },
      "placeholders": {
        "code": "напр. SITE1",
        "name": "Название",
        "address": "Адрес",
        "phone": "Телефон",
        "latitude": "47.49",
        "longitude": "19.04"
      },
      "form": {
        "code": "Код",
        "name": "Название",
        "address": "Адрес",
        "phone": "Телефон",
        "latitude": "Широта",
        "longitude": "Долгота",
        "create": "Создать",
        "requiredCode": "Код обязателен",
        "requiredName": "Название обязательно"
      },
      "validationCodeRequired": "Код обязателен",
      "validationAddressChars": "Адрес содержит недопустимые символы",
      "validationAddressTooLong": "Адрес слишком длинный (макс 180)",
      "validationAddressNeedStreetNumber": "Адрес должен содержать улицу и номер",
      "empty": "Нет площадок. Создайте одну.",
      "code": "Код",
      "name": "Название",
      "address": "Адрес",
      "phone": "Телефон"
    },
    "docs": {
      "title": "Documentation",
      "intro": "Overview of the application by user roles.",
      "menu": {
        "title": "Sections"
      },
      "backTop": "Back to top",
      "general": {
        "title": "General Information",
        "purpose": "SmartBin helps operate bins transparently and in real time: it shows current fill level, battery status and lock state, assists with collection planning, and distributes media messages (audio/images).",
        "structure": "The app is straightforward: the left menu gives access to the main features (Bins, Sites, Files, Users, Settings, Logs). In Bins, view map and list with details, charts and history. In Files, manage audio/image files and assign them to bins. Logs shows an audit trail of key operations and events.",
        "features": {
          "mapList": "Map and list: quick overview with color-coded fill, battery and lock indicators.",
          "collection": "Collection list: filter by site and thresholds; printable/exportable.",
          "media": "Media: upload and distribute audio/image files; device acknowledgements (ACK) appear in Logs.",
          "sites": "Sites: manage locations to which bins belong.",
          "users": "Users: add, edit, change passwords; permissions differ by role.",
          "settings": "Settings: language and telemetry thresholds (battery, fill) affecting displayed indicators.",
          "logs": "Logs: auditing of essential system and user actions, with details and period filters."
        },
        "roles": "Roles: users can browse and view; managers and admins can modify, delete and administer the system. Superadmin has system-wide permissions and may remain hidden in some lists.",
        "tips": "Tips: use filters to find quickly; lists can be sorted and exported. If a device is offline/unreachable, indicators reflect that. Errors and acknowledgements are visible in Logs."
      },
      "legend": {
        "title": "Legend",
        "fill": {
          "title": "Fill",
          "green": "Green",
          "yellow": "Yellow",
          "red": "Red",
          "none": "No data"
        },
        "battery": {
          "title": "Battery",
          "ok": "OK",
          "low": "Low"
        },
        "lock": {
          "title": "Lock",
          "closed": "Closed",
          "open": "Open"
        },
        "signal": {
          "title": "Signal",
          "excellent": "Excellent",
          "good": "Good",
          "weak": "Weak"
        },
        "mediaAck": {
          "title": "Media ACK",
          "ok": "OK",
          "fail": "Fail"
        },
        "media": {
          "title": "Media",
          "audio": "Audio",
          "image": "Image"
        },
        "roles": {
          "title": "Roles",
          "superadmin": "Superadmin",
          "admin": "Admin",
          "manager": "Manager",
          "user": "User"
        },
        "sites": {
          "title": "Sites",
          "code": "Code",
          "location": "Location"
        }
      },
      "bins": {
        "title": "Bins",
        "overview": "In the Bins menu you can view the map, list and selected bin details.",
        "steps1": "Click “Bins” in the left menu. Use the top tabs to switch between Map and List. On the map click an icon for details; in the list click a row.",
        "map": "Map: color-coded icons (green/yellow/red), battery and lock overlays.",
        "list": "List: fill level progress bar, battery voltage, lock state, sorting.",
        "details": "Details: mini map, status cards, charts, history.",
        "manage": "Bin management: add, edit, delete, ordering, collection list generation.",
        "steps2": "New bin: top-right “+ New bin”. Edit: open details → “Edit”. Delete: click the “Delete” icon in the row.",
        "order": "Ordering: use Up/Down controls or drag in the list; save with “Save order”.",
        "collection": "Collection list: set filters (site, fill), then “Generate list”; export to PDF/CSV.",
        "userView": "As a user you can view the map and list, and details like fill level and status."
      },
      "sites": {
        "title": "Sites",
        "overview": "Manage and view sites."
      },
      "files": {
        "title": "Files",
        "overview": "Manage audio and image files, assign to bins.",
        "steps": "Open “Files”. Upload by dragging or clicking “Upload”. To assign, pick a bin then click “Assign” on the file."
      },
      "users": {
        "title": "Users",
        "overview": "Manage users: create, edit, delete, change password.",
        "steps": "Go to “Users”. New user: “+ New user”. Edit: “Edit” icon in the row. Role: choose from dropdown."
      },
      "settings": {
        "title": "Settings",
        "overview": "Global settings: language, telemetry thresholds (battery, fill), audit logging.",
        "steps": "Go to “Settings”. In Telemetry set battery low threshold and fill thresholds, then save.",
        "tips": "Tip: hover (i) icons for more info. If green upper ≤ red lower, Save may be disabled."
      },
      "admin": {
        "title": "Admin features",
        "overview": "Audit logs, role management, system configuration and advanced settings."
      },
      "logs": {
        "title": "Logs",
        "overview": "The Logs menu shows audit records and events. Filter by time, entity and action; details show before/after states of changes.",
        "mediaAck": "Media (image/audio) delivery acknowledgements (ACK) are highlighted and appear instantly via realtime events."
      }
    },
    "confirmBin": {
      "titleDelete": "Delete Bin",
      "titleRestore": "Restore Bin",
      "messageDelete": "Are you sure you want to soft delete this bin? It will disappear from the map until restored.",
      "messageRestore": "Restore this bin? It will appear again on the map.",
      "proceed": "Yes",
      "cancel": "Cancel"
    }
  }
};
